<!-- компонент Element: элемент формы редактирования -->
<template>

	<!-- корень элемента - враппер -->
	<div :class="{
		'w5-field': isVisibleRow && Field._field_name !== 'role_items',
		'padding-for-submit-button': needButtonSubmit === true,
		'removeRightPadding': removeRightPadding,
		'removeAllPadding': Field.type === 'passport' || Field.type === 'address',
		'w5-disabled-field': Field.readonly === true,
		'w5-vds-plan': isUniqueInVds() || isUniqueInOperation() || isUniqueInCertificate(),
		'w5-filed-with-top-hint': topHint,
		'w5-filed-with-bottom-hint': bottomHint,
		'w5-fake-field': Field.type === 'fake',
		'w5-combo-list': crud === 'domains' && Field['_field_name'] === 'person_id',
		'w5-field-greyed': isFieldGreyed,
		'with-awesome-button': fontawesomeButton,
		'with-big-button': (Field.type != 'text' && Field.type != 'boolean') && bigButton,
		'header': Field.type === 'header',
		'clear-text': Field.type === 'clearText',
		'w5-iso-download-field': crud === 'iso' && (Field['_field_name'] === 'download' || Field['_field_name'] === 'library'),
		'w5-autoprolong-field': crud === 'disks' && Field['_field_name'] === 'autoprolong'
	}" v-show="fieldVisible">

		<!-- если поле "засерено" -->
		<div v-if="isFieldGreyed" class="w5-field-greyed-back"></div>

		<!-- тип поля сюда для внешних форм -->
		<span :data-input-type="Field.type" style="display: none"></span>

		<!-- подсказки перед полем -->
		<div v-if="topHint" class="w5-field-top-hint"><span v-withSafeTags="localeFtc(topHint)"></span></div>

		<!-- анимированный заголовок элемента -->
		<div v-show="fieldPlaceholderVisible"
			class="w5-field-placeholder"
			:class="{
				'active': fieldFocused || notEmpty(fieldCurValue),
				'textarea': Field.type === 'textarea',
				'short': Field._is_short === true,
				'readonly': Field.readonly === true,
				'field-in-modal': fieldInModal,
				'search-in-modal': fieldInModal && Field && Field._field_name === 'fastSearch'
			}">{{ Field.title | ftc }}<span v-if="Field.required === true" class="required-field"> *</span></div>

		<!-- поле элемента формы - HIDDEN -->
		<template v-if="Field.type === 'hidden'">
			<input type="hidden"
				:name="Field._field_name"
				:ref="Field._field_name"
				v-model="fieldCurValue" />
		</template>

		<!-- поле элемента формы - clearText -->
		<span v-if="Field.type === 'clearText'" class="shown-text">
			<div v-if="Field.__subtype === 'rackdevice-from'" class="lamp" :class="{ active: Field.__isPortActive }"></div>
			{{ fieldCurValue }}
		</span>

		<!-- поле элемента формы - TEXT -->
		<template v-if="Field.type === 'text'">

			<template v-if="crud === 'dns-records' && Field['_field_name'] === 'host' && !Field.readonly">
				<domainInput
					:class="{ 'haserror': fieldError, 'with-submit-button': needButtonSubmit === true }"
					:name="Field._field_name"
					:ref="Field._field_name"
					placeholder=""
					:fixed="dnsFixedValue"
					v-model="fieldCurValue"
					@input="onChange"
					@focus="fieldFocus"
					@blur="fieldBlur"
					@keydownEnter="enterKeyDown" />
			</template>
			<template v-else>
				<input type="text" class="text-field"
					:class="{ 'haserror': fieldError, 'paddingWithButton': clearButton, 'bitbtn-in-field': bigButton }"
					:name="Field._field_name"
					:ref="Field._field_name"

					:autocomplete="Field._field_name === 'fastSearch' ? 'off' : null"
					:readonly="Field._field_name === 'fastSearch'"

					placeholder=""
					:disabled="Field.readonly === true ? 'disabled' : false"
					:autofocus="Field._field_name === 'code' && crud === 'twofa'" 
					v-model="fieldCurValue"
					@input="onChange"
					@focus="fieldFocus"
					@blur="fieldBlur"
					@keydown.enter="enterKeyDown" />
			</template>

			<div v-if="clearButton" class="field-button-wrapper" :class="{ 'bitbtn-in-field': bigButton, 'search-in-modal': fieldInModal && Field && Field._field_name === 'fastSearch' }" @click="clearButtonClick">
				<font-awesome-icon icon="times" />
			</div>

			<div v-if="searchButton" class="field-button-wrapper" @click="searchButtonClick">
				<font-awesome-icon icon="search" />
			</div>

			<span v-if="bigButton" class="btn btn-submit bitbtn-in-field" @click="enterKeyDown">{{ bigButtonTitle | ftc }}</span>

			<div v-if="(crud === 'ticket' && action === 'create') || (crud === 'qa' && action === 'list')" v-show="qaResult" class="w5-field-qa-result">
				<strong>В нашем QA есть похожие вопросы</strong>: <br>
				<ul>
					<li v-for="(qa, indx) in qaResult" :key="'qa-item-' + indx"><a :href="QAURL + '/q/' + qa.url" target="_blank">{{ qa.cap }} ({{ qa.ans }})</a></li>
				</ul>
			</div>
		</template>

		<!-- поле элемента формы - MONEY -->
		<template v-if="Field.type === 'money'">
			<numberInput
				class="paddingWithButton"
				:class="{ 'haserror': fieldError, 'with-submit-button': needButtonSubmit === true }"
				:name="Field._field_name"
				:ref="Field._field_name"
				:type="Field.type"
				:crud="crud"
				placeholder=""
				:disabled="Field.readonly === true ? 'disabled' : false"
				v-model="fieldCurValue"
				@animation="animationRequested"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur"
				@keydownEnter="enterKeyDown" />

			<div v-if="Field.for" class="field-postfix-wrapper" :class="{ 'with-top-hint': topHint }">
				<span v-html="localeFtc(Field.for)"> </span>
			</div>
			<div v-else class="field-postfix-wrapper" :style="needButtonSubmit === true ? 'right: 76px !important' : false" :class="{ 'with-top-hint': topHint }">
				<span v-html="localeFtc('main/ruble')"> </span>
			</div>
		</template>

		<!-- поле элемента формы - INTEGER -->
		<template v-if="Field.type === 'integer'">
			<numberInput
				:class="{ 'haserror': fieldError, 'paddingWithButton': Field.for }"
				:name="Field._field_name"
				:ref="Field._field_name"
				:type="Field.type"
				placeholder=""
				:disabled="Field.readonly === true ? 'disabled' : false"
				v-model="fieldCurValue"
				:needReact="needReact"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur"
				@keydownEnter="enterKeyDown" />

			<div v-if="Field.for" class="field-postfix-wrapper">
				<span v-html="localeFtc(Field.for)"> </span>
			</div>
		</template>

		<!-- поле элемента формы - FLOAT -->
		<template v-if="Field.type === 'float'">
			<numberInput
				:class="{ 'haserror': fieldError, 'paddingWithButton': Field.for }"
				:name="Field._field_name"
				:ref="Field._field_name"
				:type="Field.type"
				placeholder=""
				:disabled="Field.readonly === true ? 'disabled' : false"
				v-model="fieldCurValue"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur"
				@keydownEnter="enterKeyDown" />

			<div v-if="Field.for" class="field-postfix-wrapper">
				<span v-html="localeFtc(Field.for)"> </span>
			</div>
		</template>

		<!-- поле элемента формы - RADIO -->
		<template v-if="Field.type === 'radio'">
			<radioListComponent
				:class="{ 'haserror': fieldError }"
				:ref="Field._field_name"
				:disabled="Field.readonly === true ? 'disabled' : false"
				:title = "Field.title"
				:required="Field.required"
				:items="filterActiveList(Field.list)"
				placeholder=""
				v-model="fieldCurValue"
				@input="onChange" />
		</template>

		<!-- поле элемента формы - LIST static -->
		<template v-if="Field.type === 'list' && !isUniqueInVds() && !isUniqueInOperation() && !isUniqueInCertificate() && !isUniqueInDomains()">
			
			<!-- выбор нескольких значений -->
			<template v-if="Field.multiselect === true">
				<!-- поле выбора ролей -->
				<userRole v-if="crud === 'user' && Field['_field_name'] === 'role_items'"
					v-model="fieldCurValue"
					:title="Field['title']"
					:name="Field['_field_name']"
					:ref="Field['_field_name']"
					:master="Field['list_description']"
					:slave="Field['list']"
					@focus="fieldFocus"
					@input="onSelectUserRole" />
				<!-- динамический набор данных (задан URL) -->
				<multiselect v-else-if="Field.url && Field['_field_name'] !== 'plans' && Field['_field_name'] !== 'templates'"
					v-model="listValue"
					class="w5-multiselecting w5-selecting-by-url"
					:class="{ 'haserror': fieldError }"
					placeholder=""
					label="name"
					:options="curList"
					:showLabels="false"
					:allowEmpty="true"
					:searchable="true"
					:multiple="true"
					track-by="id"
					:ref="Field._field_name"
					:disabled="Field.readonly === true"
					:internalSearch="false"
					:showNoOptions="false"
					@input="onSelect"
					@open="onListOpen"
					@close="onListClose"
					@search-change="asyncListFind">
					<span slot="beforeList" v-show="statusListRequestProcess.trim().length" style="padding-left: 20px">{{ statusListRequestProcess | ftc }}</span>
					<span slot="noResult" v-show="statusListRequestResult.trim().length">{{ statusListRequestResult | ftc }}</span>
				</multiselect>
				<!-- статический набор данных -->
				<multiselect v-else
					v-model="listValue"
					class="w5-multiselecting w5-selecting-by-static"
					:class="{ 'haserror': fieldError }"
					placeholder=""
					label="name"
					:options="curList"
					:showLabels="false"
					:allowEmpty="true"
					:searchable="false"
					:multiple="true"
					track-by="id"
					:ref="Field._field_name"
					:disabled="Field.readonly === true ? true : false"
					:showNoOptions="false"
					@input="onSelect"
					@open="onListOpen"
					@close="onListClose">
					<template slot="tag" slot-scope="props">
						<span class="multiselect__tag" :class="{ 'multiselect__option--notactive-tag': props.option.active === false || props.option.archive === true }">
							<span v-text="scopedGetOptionLabel(props.option)"></span>
							<i aria-hidden="true" tabindex="1" @keydown.enter.prevent="scopedRemoveElement(props.option)" @mousedown.prevent="scopedRemoveElement(props.option)" class="multiselect__tag-icon"></i>
						</span>
					</template>
				</multiselect>
			</template>
			<!-- выбор одного значения -->
			<template v-else>
				<!-- динамический набор данных (задан URL) -->
				<multiselect v-if="Field.url && (Field._field_name !== 'sshkey_id' && Field._field_name !== 'person_id' && Field._field_name !== 'operation_id')"
					v-model="listValue"
					class="w5-singleselecting w5-selecting-by-url"
					:class="{ 'haserror': fieldError, 'short-list': Field._is_short === true }"
					placeholder=""
					label="name"
					:options="isUrlWithQuery ? curList : preparedStaticList(curList)"
					:showLabels="false"
					:allowEmpty="false"
					:searchable="isSelectSearchable"
					:ref="Field._field_name"
					:disabled="Field.readonly === true ? true : false"
					:internalSearch="false"
					:showNoOptions="false"
					track-by="id"
					@input="onSelect"
					@open="onListOpen"
					@close="onListClose"
					@search-change="(str) => isUrlWithQuery ? asyncListFind(str) : mySearchFunction(str)">
					<span slot="beforeList" v-show="statusListRequestProcess.trim().length" style="padding-left: 20px">{{ statusListRequestProcess | ftc }}</span>
					<span slot="noResult" v-show="statusListRequestResult.trim().length">{{ statusListRequestResult | ftc }}</span>
					<template slot="option" slot-scope="props">
						<span v-if="Field._field_name === 'server_id' && props.option.type" :class="'color-type-' + String(props.option.type)" style="font-size: 13px">&#9679;</span>
						{{ props.option.name }}
					</template>
				</multiselect>
				<!-- статический набор данных -->
				<multiselect v-else
					v-model="listValue"
					class="w5-singleselecting"
					:class="{
						'haserror': fieldError,
						'short-list': Field._is_short === true,
						'domains-person-with-button': crud === 'domains' && Field['_field_name'] === 'person_id'
					}"
					placeholder=""
					label="name"
					:options="preparedStaticList(curList)"
					:showLabels="false"
					:allowEmpty="false"

					:searchable="curList.length > 15 && crud !== 'backupschedule'"
					:internalSearch="false"
					:maxHeight="$store.state.windowWidth <= 767 ? 200 : 300"
					@search-change="mySearchFunction"

					track-by="id"

					:ref="Field._field_name"
					:disabled="Field.readonly === true ? true : false"
					:showNoOptions="false"
					@input="onSelect"
					@open="onListOpen"
					@close="onListClose">
					<span slot="noResult">{{ 'main/search_not_found' | ftc }}</span>
					<template slot="option" slot-scope="props">
						<template v-if="(crud === 'certificate' || crud === 'datacenter' || crud === 'person') && Field._field_name.indexOf('country') > -1">
							<span class="flag-icon" :class="'flag-icon-' + props.option.id.toLowerCase()" style="margin-right: 10px; top: -1px;"></span>
							{{ props.option.name }}
						</template>
						<template v-else-if="crud === 'backupDialog' && Field._field_name === 'service_id'">
							<div class="backup-dialog-service-option">
								<img v-if="props.option.template && props.option.template.image" :src="APIServerUrl + props.option.template.image" />
								<div class="plan">
									<div>
										<span class="flag-icon" :class="'flag-icon-' + props.option.datacenter.country.toLowerCase()"></span>
										<span :class="{ not: !props.option.active }">{{ props.option.name }}</span>
									</div>
									<div v-if="props.option.plan && props.option.plan.data">
										<span class="plan-info">{{ getPlanInfo(props.option.plan.data) }}</span>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<span v-if="Field._field_name === 'migrateModalServerValue' && props.option.type" :class="'color-type-' + String(props.option.type)" style="font-size: 13px">&#9679;</span>
							{{ props.option.name }}
						</template>
					</template>
				</multiselect>
			</template>

		</template>

		<!-- поле выбора группы тарифов в VDS -->
		<template v-if="Field._field_name === 'plan_group_id' && crud === 'vds' && action === 'create'">
			<groupPlanComponent
				:action="action"
				:groups="filterActiveList(Field['list'])"
				v-model="fieldCurValue"
				@focus="emitFocus"
				@groupChanged="onGroupChanged" />
		</template>

		<!-- поле выбора тарифа в VDS -->
		<template v-if="Field._field_name === 'plan_id' && crud === 'vds'">
			<planComponent
				:items="filterActiveList(Field.list)"
				:action="action"
				:groups="groupField && groupField['list'] ? groupField['list'] : null"
				:groupValue="groupField && groupField['value'] ? groupField['value'] : null"
				:cookieValue="Field && Field.cookieValue ? Field.cookieValue : null"
				:templateField="templateField"
				v-model="fieldCurValue"
				@focus="emitFocus"
				@startData="onStartData"
				@groupChanged="onGroupChanged"
				@input="onChange"
				@params="onParams" />
		</template>

		<!-- поле выбора шаблона в VDS -->
		<templateImageComponent
			v-if="Field._field_name === 'template_id' && crud === 'vds'"
			:action="action"
			:formFields="formFields"
			:planField="planField"
			:cookieValue="Field && Field.cookieValue ? Field.cookieValue : null"
			:dc="dc"
			@focus="emitFocus"
			@startData="onStartData"
			@templateTab="onTemplateTab"
			@templateInput = "onTemplateInput"
			@backupList="onBackupList" />

		<!-- поле выбора датацентра в VDS -->
		<template v-if="Field._field_name === 'datacenter_id' && (crud === 'vds' || crud === 'disks')">
			<countryComponent
				:items="filterListForDataCenterInVds(Field.list)"
				:crud="crud"
				:action="action"
				:readonly="Field.readonly"
				v-model="fieldCurValue"
				@focus="emitFocus"
				@startData="onStartData"
				@input="onChange" />
		</template>

		<!-- поле выбора бэкапа внешних дисков -->
		<template v-if="Field._field_name === 'backup_id' && crud === 'disks'">
			<backupComponent
				v-model="fieldCurValue"
				:action="action"
				:list="Field && Field.list && Field.list.length ? Field.list : []"
				:readonly="Field.readonly"
				@focus="emitFocus"
				@input="onChange" />
		</template>

		<!-- поле выбора тарифа в SSL -->
		<template v-if="isUniqueInCertificate()">
			<planSslComponent
				:title="Field.title"
				:required="Field.required"
				:items="filterActiveList(Field.list)"
				:groups="groupField && groupField['list'] ? groupField['list'] : null"
				:groupValue="groupField && groupField['value'] ? groupField['value'] : null"
				:cookieValue="Field && Field.cookieValue ? Field.cookieValue : null"
				v-model="fieldCurValue"
				@focus="emitFocus"
				@startData="onStartData"
				@groupChanged="onGroupChanged"
				@input="onChange" />
		</template>

		<!-- поле выбора тарифа в Domains -->
		<template v-if="isUniqueInDomains()">
			<planDomainComponent
				:Field="Field"
				:items="filterActiveList(Field.list)"
				:nameField="nameField"
				:actionField="actionField"
				v-model="fieldCurValue"
				@focus="emitFocus"
				@blur="emitBlure"
				@onDomainName="onDomainName"
				@keydownEnter="enterKeyDown"
				@startData="onStartData"
				@input="onChange" />
		</template>

		<!-- поле выбора способа оплаты при пополнении баланса клиентом -->
		<template v-if="isUniqueInOperation()">
			<paymentComponent
				:items="Field.list"
				:title="Field.title"
				v-model="fieldCurValue"
				@focus="emitFocus"
				@input="onChange"
				@operationNextStep="onClientOperationNextStep" />
		</template>

		<!-- поле элемента формы - PASSWORD -->
		<template v-if="Field.type === 'password'">
			<input v-if="Field.generator"
				:type="passwordIsShown ? 'text' : 'password'"
				class="paddingWithButton eye" 
				:class="{ 'haserror': fieldError }"
				:name="Field._field_name"
				:ref="Field._field_name"
				placeholder=""
				:disabled="Field.readonly === true ? 'disabled' : false"
				autocomplete="nope"
				v-model="fieldCurValue"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur"
				@keydown.enter="enterKeyDown" />

			<input v-else
				type="password"
				:class="{ 'haserror': fieldError }"
				:name="Field._field_name"
				:ref="Field._field_name"
				placeholder=""
				:disabled="Field.readonly === true ? 'disabled' : false"
				autocomplete="new-password"
				v-model="fieldCurValue"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur"
				@keydown.enter="enterKeyDown" />

			<div v-if="Field.generator" class="field-button-wrapper field-button-password-wrapper eye" :class="{ 'in-modal': fieldInModal, 'slash': passwordIsShown }" :title="`${passwordIsShown ? 'main/hide' : 'main/show'} main/password` | ftc" @click="togglePasswordVisibility">
				<font-awesome-icon :icon="passwordIsShown ? 'eye-slash' : 'eye'" />
			</div>
			<div v-if="Field.generator" class="field-button-wrapper field-button-password-wrapper" :class="{ 'in-modal': fieldInModal }" :title="'main/password_generation' | ftc" @click="generatePasswordHandler">
				<font-awesome-icon icon="random" />
			</div>
		</template>

		<!-- поле элемента формы - EMAIL -->
		<template v-if="Field.type === 'email'">
			<input type="email"
				:class="{ 'haserror': fieldError }"
				:name="Field._field_name"
				:ref="Field._field_name"
				placeholder=""
				:disabled="Field.readonly === true ? 'disabled' : false"
				autocomplete="nope"
				v-model="fieldCurValue"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur"
				@keydown.enter="enterKeyDown" />
		</template>

		<!-- поле элемента формы - TEXTAREA -->
		<template v-if="Field.type === 'textarea'">
			<textarea :class="{ 'haserror': fieldError }"
				:name="Field._field_name"
				:ref="Field._field_name"
				placeholder=""
				:disabled="Field.readonly === true ? 'disabled' : false"
				v-model="fieldCurValue"
				:style="textAreaStyle()"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur">
			</textarea>
			<!-- если это сообщение тикета у сотрудника - нужна кнопка показа диалога -->
			<font-awesome-icon v-if="$store.state.user_type === 'admin' && (crud === 'ticketmessage' || crud === 'ticket') && action === 'create'"
				icon="list-alt"
				class="ticket-answer-template-btn"
				:title="'mails/templates' | ftc"
				@click="templateDialog"
			/>
		</template>

		<!-- поле элемента формы - slider -->
		<template v-if="Field.type === 'slider'">
			<OuterDiskType v-if="crud === 'disks' && action === 'create' && Field._field_name === 'quantity'"
				style="margin-bottom: 20px; margin-top: -10px;"
				:value="diskTypeValue"
				@input="onOuterDiskTypeChanged" />
			<div class="graph-slider-wrapper" :class="action">
				<div class="input-text-slider">
					<div class="input-text-slider-field-wrapper">
						<div class="input-slider-field-placeholder">{{ Field.title | ftc }}<span v-if="Field.required" class="required-field"> *</span></div>
						<input type="text"
							class="input-slider-field"
							:value="outerDiskValue"
							:ref="'field-' + Field._field_name"
							:disabled="Field.readonly === true ? 'disabled' : false"
							@blur="onSliderFieldBlurNew"
						/>
						<div class="input-slider-field-postfix"><span>{{ Field.for }}</span></div>
					</div>
					<div v-if="outerDiskError" class="input-slider-field-error">
						{{ outerDiskError | ftc }}
					</div>
				</div>
				<div class="graph-slider">
					<div class="title">
						<span v-if="'cost' in Field && 'period' in Field" class="pull-right">
							{{ 'servicetype/cost' | ftc }}: <strong>{{ outerDisksPrice | moneyOnlyNumbers }}
							<span v-html="localeFtc('main/ruble')"> </span> / {{ Field.period | ftc }}</strong>
						</span>
					</div>
					<div class="slider">
						<vue-slider v-model="fieldCurValue"
							:ref="Field._field_name"
							:min="0"
							:max="'max' in Field ? Field.max : 1"
							:duration="0.2"
							:marks="sliderMarks"
							:interval="'step' in Field ? Field.step : 1"
							:silent="true"
							:disabled="Field.readonly === true ? 'disabled' : false"
							:labelStyle="{ fontSize: '10px', fontWeight: 300, color: '#666', top: '2px' }"
							tooltip="none"
							@drag-start="$emit('dragStart')"
							@drag-end="$emit('dragEnd')"
							@change="onChange">
							<div class="process-minimum" :style="minRangeWidthStyle"></div>
						</vue-slider>
					</div>
				</div>
			</div>
		</template>

		<!-- поле элемента формы - DATETIME -->
		<DateTime v-if="Field.type === 'datetime'"
			:class="{ 'haserror': fieldError }"
			:name="Field._field_name"
			:ref="Field._field_name"
			placeholder=""
			:disabled="Field.readonly === true"
			@input="datetimeInput"
			v-model="fieldCurValue" />
		
		<!-- поле элемента формы - DATE -->
		<template v-if="Field.type === 'date'">
			<manualDateComponent v-if="crud === 'person' && (Field._field_name === 'data[ru_phis][birth_date]' || Field._field_name === 'data[birth_date]')"
				:class="{ 'haserror': fieldError }"
				:ref="Field._field_name"
				:key="Field._field_name"
				:required="Field.required"
				:disabled="Field.readonly === true ? 'disabled' : false"
				v-model="fieldCurValue"
				@error="onError"
				@input="onChange"
				@focus="fieldFocus"
				@blur="fieldBlur"
				@keydown.enter="enterKeyDown" />
			<datepicker v-else
				:name="Field._field_name"
				:id="Field._field_name"
				:key="Field._field_name"
				:class="{ 'haserror': fieldError }"
				:ref="Field._field_name"
				placeholder=""
				:disabled-picker="Field.readonly === true ? 'disabled' : false"
				v-model="fieldCurValue"
				format="dd.MM.yyyy"
				:language="$store.state.lang === 'en' ? 'en' : 'ru'"
				wrapper-class="w5-field-date-wrapper"
				input-class="w5-field-date-input"
				:typeable="true"
				@opened="onDateOpen"
				@closed="onDateClose"
				@selected="onDateSelect"
				:monday-first="true"
				:clear-button="true" />
		</template>

		<passportComponent v-if="Field.type === 'passport'"
			:class="{ 'haserror': fieldError }"
			:name="Field._field_name"
			:ref="Field._field_name"
			:required="Field.required"
			:readonly="Field.readonly"
			:errorMessage="Field._errMsg"
			v-model="fieldCurValue"
			@error="onError"
			@input="onChange"
			@focus="fieldFocus"
			@blur="fieldBlur"
			@enterKeyDown="enterKeyDown" />

		<phoneComponent v-if="Field.type === 'phone'"
			:class="{ 'haserror': fieldError }"
			:ref="Field._field_name"
			:key="Field._field_name"
			:required="Field.required"
			:disabled="Field.readonly === true ? 'disabled' : false"
			v-model="fieldCurValue"
			@error="onError"
			@input="onChange"
			@focus="fieldFocus"
			@blur="fieldBlur"
			@keydown.enter="enterKeyDown" />

		<addressComponent v-if="Field.type === 'address'"
			:class="{ 'haserror': fieldError }"
			:name="Field._field_name"
			:title="Field.title"
			:validator="Field.validator"
			:ref="Field._field_name"
			:required="Field.required"
			:readonly="Field.readonly"
			:errorMessage="Field._errMsg"
			:crud="crud"
			v-model="fieldCurValue"
			@copyAddress="copyAddress"
			@error="onError"
			@input="onChange"
			@focus="fieldFocus"
			@blur="fieldBlur"
			@enterKeyDown="enterKeyDown" />

		<!-- поле элемента формы - BOOLEAN -->
		<div v-if="Field.type === 'boolean'" class="w5-boolean-field-wrapper" :class="{ 'outer-disks-update': crud === 'disks' && action === 'update' }">
			<input type="checkbox" class="w5-checkbox-field" :name="Field._field_name" v-model="fieldCurValue" style="display: none" />
			<label @click="clickBooleanLabel" class="w5-boolean-label">
				{{ Field.title | ftc }}
					<template v-if="crud === 'vds' && action ==='create' && Field._field_name === 'backup_auto'">
						<span v-if="BackupItemCost" class="backup-item-cost">
							<span class="hidden-xs">&rarr;</span>
							<span class="visible-xs" style="margin:5px">&darr;</span>
						</span>
						<span v-if="isBackupItemDiscountCost" v-withSafeTags="BackupItemDiscountCost" class="price-with-discount"></span>
						<span v-else v-withSafeTags="BackupItemCost"></span>
					</template>
				<template v-if="crud === 'domains' && action ==='update' && Field._field_name === 'privacy_set' && Field.period && 'cost' in Field"> <span class="backup-item-cost"><span class="hidden-xs">&rarr;</span><span class="visible-xs" style="margin:5px">&darr;</span></span> <span v-withSafeTags="BooleanFieldCost"></span></template>
				<template v-if="Field.hint">
					<span v-if="crud === 'vds' && action ==='create' && Field._field_name === 'options'" class="w5-boolean-hint">{{ Field.hint | ftc }}</span>
					<span v-else-if="crud === 'disks' && action ==='update' && Field._field_name === 'autoprolong'"></span>
					<span v-else-if="fieldCurValue === true" class="w5-boolean-hint">{{ Field.hint | ftc }}</span>
				</template>
			</label>
			<div v-if="crud === 'disks' && action ==='update' && Field._field_name === 'autoprolong'" class="outer-disks-hint" v-withSafeTags="localeFtc('service/autoprolong_off')"></div>
			<!-- большая кнопка после поля -->
			<span v-if="bigButton" class="btn btn-submit bitbtn-in-field not-text" @click="bigButtonHandlerFunc" :class="{ 'disabled': bigButtonEnabled !== true }">{{ bigButtonTitle | ftc }}</span>
			<!-- текст и ссылка после поля -->
			<span v-if="Field.after_text && Field.after_url && $store.state.user_type === 'admin'">&nbsp;</span><linkComponent v-if="Field.after_text && Field.after_url && $store.state.user_type === 'admin'" :url="generateAfterUrl" :text="'(' + Field.after_text + ')' | ftc" class="link-by-boolean" />
		</div>

		<!-- поле элемента формы - IMAGE or FILE -->
		<template v-if="Field.type === 'image' || Field.type === 'file'">
			<directFileComponent v-if="crud === 'iso' && action === 'create'"
				:name="Field._field_name"
				:title="Field.title"
				:ref="Field._field_name"
				:accept="Field.accept"
				:maxsize="Field.maxsize"
				:maxcnt="Field.max ? Field.max : 1"
				v-model="fieldCurValue"
				@input="onChange"
				@focus="Field._errMsg = ''"
				@uploadCanceled="onIsoUploadCanceled"
				@uploadFinished="onIsoUploadFinished"
				@uploadError="onIsoUploadError" />

			<fileComponent v-else
				:crud="crud"
				:name="Field._field_name"
				:title="Field.title"
				:ref="Field._field_name"
				:accept="Field.accept"
				:maxsize="Field.maxsize"
				:maxcnt="Field.max"
				:multiple="Field.multifile"
				:candel="Field._canDelete"
				v-model="fieldCurValue"
				@input="onChange"
				@abortUpload="onChange"
				@uploadFinished="onUploadFinished"
				@blockFormButton="blockFormButton"
				@unblockFormButton="unblockFormButton"
				@deleteFileValue="deleteFileValue"
				@cropCoords="cropCoords" />
		</template>

		<!-- поле элемента формы - URLLINK -->
		<template v-if="Field.type === 'urlButton'">
			<urlButtonComponent
				:crud="crud"
				:name="Field._field_name"
				:url="Field.urlLink"
				:text="Field.urlText"
				:ref="Field._field_name" />
		</template>

		<!-- поле элемента формы - simpleButton -->
		<template v-if="Field.type === 'simpleButton'">
			<span :crud="crud" :name="Field._field_name" :ref="Field._field_name" @click.stop="Field.buttonFunction" class="url-button">
				<font-awesome-icon v-if="crud === 'vds' && Field._field_name === 'sshkey_id'" icon="plus-circle" style="font-size: 24px; top: 3px;" />
				{{ Field.buttonText | ftc }}
			</span>
		</template>

		<!-- поле элемента формы - savedPayments -->
		<template v-if="Field.type === 'savedPayments'">
			<savedPaymentsComponent
				v-model="fieldCurValue"
				:crud="crud"
				:action="action"
				:title="Field.title"
				:required="Field.required"
				:items="Field.list"
				:readonly="Field.readonly"
				@focus="fieldFocus"
				@input="onChange"
				@deleteSavedPayment="onDeleteSavedPayment"
				@operationNextStep="onClientOperationNextStep"
			/>
		</template>

		<!-- подсказка -->
		<transition v-if="Field.hint && Field.type !== 'boolean' && Field.type !== 'passport' && Field.type !== 'address'" name="fade" mode="out-in">
			<div class="w5-tooltip-wrapper" v-show="Field.hint && fieldFocused && !fieldError">
				<span class="w5-tooltip">{{ (crud === 'person' ? 'person/pattern: ' : '') + Field.hint | ftc }}</span>
			</div>
		</transition>

		<!-- дополнительное поле элемента формы DOMAINS - URLLINK -->
		<template v-if="crud === 'domains' && Field['_field_name'] === 'person_id'">
			<urlButtonComponent
				class="domains-person-create-button"
				:crud="crud"
				:name="Field._field_name"
				url="/person/create"
				text="Создать персону" />
		</template>

		<!-- header - разделитель -->
		<div v-if="Field.type === 'header'" class="header">
			<span v-if="Field.number && !(crud === 'disks' && fieldInModal)" class="step">{{ Field.number }}</span>
			{{ Field.title | ftc }}
		</div>

		<!-- кнопка fontawesome -->
		<font-awesome-icon v-if="fontawesomeButton" :icon="fontawesomeButton" class="fontawesome-btn" :class="fontawesomeButton" @click.stop="() => $emit('fontawesomeButton', { button: fontawesomeButton, field: Field._field_name })" />

		<!-- Блок с ошибками -->
		<div v-if="!isUniqueInDomains() && Field.type !== 'passport' && Field.type !== 'address'"
			v-show="fieldError"
			class="alert alert-danger w5-alert-valid"
			:class="{ 'domains-person-error-message': crud === 'domains' && Field['_field_name'] === 'person_id', 'url-btn': Field.type == 'urlButton' }"
			role="alert"
			v-withSafeTags="localeFtc(fieldError)" />

		<!-- Блок с предупреждением -->
		<div v-if="Field.warningList"
			class="alert alert-danger w5-alert-valid warning"
			role="alert"
			v-withSafeTags="localeFtc(Field.warningList)" />

		<!-- подсказки под полем -->
		<div v-if="bottomHint" class="w5-field-bottom-hint"><span v-withSafeTags="localeFtc(bottomHint)"></span></div>

		<!-- подсказки справа от поля -->
		<div v-if="rightHint" class="w5-field-right-hint" :class="'count-' + countVisibleFieldsInRow"><span v-withSafeTags="localeFtc(rightHint)"></span></div>

		<!-- подсказки вместо поля -->
		<div v-if="insteadFieldHint" class="w5-field-instead-hint" :class="{ error: crud === 'paymentauto' && Field._field_name === 'saved_id' && (!Field.list || !Field.list.length) }"><span v-withSafeTags="localeFtc(insteadFieldHint)"></span></div>

		<!-- большая кнопка после не текстового поля -->
		<template v-if="(Field.type != 'text' && Field.type != 'boolean') && bigButton">
			<span v-if="Field.type == 'fake' || Field.value" class="btn btn-submit bitbtn-in-field not-text" @click="bigButtonHandlerFunc" :class="{ 'disabled': bigButtonEnabled !== true }">{{ bigButtonTitle | ftc }}</span>
		</template>

		<!-- большая кнопка ссылки после не текстового поля -->
		<template v-if="linkButton && linkButtonVisible && linkButtonUrl">
			<router-link :to="linkButtonUrl" class="btn btn-submit bitbtn-in-field not-text green">{{ linkButtonTitle | ftc }}</router-link>
		</template>

		<!-- кнопка закрытия -->
		<template v-if="needButtonSubmit === true">
			<button type="button" class="btn btn-submit btn-in-field" @click="onSubmitButton"><font-awesome-icon icon="check" /></button>
		</template>

		<!-- прогресс процесса -->
		<template v-if="progress">
			<span class="w5-field-progress">
				<div class="indicator">
					<img src="/static/img/loading-hor16.gif" />
					<br>
					{{ progress }}
				</div>
				<div class="button" @click="onIsoUploadCanceled">
					<font-awesome-icon :title="'main/cancel' | ftc"
						icon="times-circle"
						style="font-size: 15px"
					/>
				</div>
			</span>
		</template>

		<!-- подсказка-ссылка не для списков -->
		<div v-if="linkHint && linkHint.showIfField === Field._field_name && Field.type !== 'list'" class="w5-info-link margin-top-5">
			<font-awesome-icon icon="link" />
			<span v-withSafeTags="linkHintHtml(linkHint)"></span>
			<span v-if="linkHint.afterText" class="font-weight-500"> {{ linkHint.afterText | ftc }}</span>
		</div>

	</div>

</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import Vue from 'vue'
import Helper from '../../helper/helper'
import numberInput from '@/components/elements/number'
import domainInput from '@/components/elements/domain'
import fileComponent from '@/components/elements/file'
import directFileComponent from '@/components/elements/directFile'
import planComponent from '@/components/elements/planNew'
import groupPlanComponent from '@/components/elements/groupPlan'
import planSslComponent from '@/components/elements/planssl'
import planDomainComponent from '@/components/elements/planDomain'
import templateComponent from '@/components/elements/template'
import templateImageComponent from '@/components/elements/tempNew'
import paymentComponent from '@/components/elements/payment'
import urlButtonComponent from '@/components/elements/urlbtn'
import countryComponent from '@/components/elements/country'
import backupComponent from '@/components/elements/backupList'
import radioListComponent from '@/components/elements/radio'
import manualDateComponent from '@/components/elements/date'
import phoneComponent from '@/components/elements/phone'
import passportComponent from '@/components/elements/passport'
import addressComponent from '@/components/elements/address'
import savedPaymentsComponent from '@/components/elements/savedPayments'
import userRole from '@/components/elements/role'
import DateTime from '@/components/elements/datetime'
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker'
import Inputmask from 'inputmask'
import OuterDiskType from '@/components/elements/outerdisktype'
//import { transliterate as trns } from 'transliteration'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// название
	//=========================================================================
	name: 'formField',
	//=========================================================================
	// данные переданные родителем
	//=========================================================================
	props: [
		// видна ли вся строка формы
		'isVisibleRow',
		// количество видимых полей в строке
		'countVisibleFieldsInRow',
		// CRUD
		'crud',
		// действие
		'action',
		// данные поля
		'Field',

		// данные по всей строке
		'objID',

		// кнопка очистки поля
		'clearButton',

		// кнопка поиска
		'searchButton',

		// внешняя кнопка fontawesome
		'fontawesomeButton',

		// правый отспу
		'removeRightPadding',

		// для v-model
		'value',

		// нужно остлеживать изменения модели или нет
		'needReact',

		// нужно выносить блок со списком "ul" наружу или нет
		'listBlockToOut',

		// признак того, что поле в модальном диалоге
		'fieldInModal',

		// нужна ли кнопка сабмита
		'needButtonSubmit',

		// дополнительная большая кнопка справа от поля
		'bigButton',
		'bigButtonTitle',
		'bigButtonHandler',
		'bigButtonEnabled',

		// дополнительная большая кнопка ссылки
		'linkButton',
		'linkButtonTitle',
		'linkButtonUrl',
		'linkButtonVisible',

		// подсказка-ссылка, привязанная к полю
		'linkHint',

		// ссылка на поле "group_id" для тарифов
		'groupField',

		// ссылка на поле "name" для тарифов регистрации доменов
		'nameField',

		// ссылка на поле "set_action" для тарифов регистрации доменов
		'actionField',

		// ссылка на поле "backup_id" для шаблонов в создании VDS
		'backupField',

		// ссылка на поле "account_id" для шаблонов в создании VDS
		'accountField',

		// ссылка на поле "plan_id" для шаблонов в создании VDS
		'planField',

		// ссылка на параметры тарифа в создании VDS
		'planParams',

		// ссылка на поле "template_id" для тарифов в создании VDS
		'templateField',

		// ссылка на все поля формы
		'formFields',

		// прогресс процесса
		'progress',

		// значение ДЦ для переустановки VDS
		'dc',

		// тип внешнего диска
		'diskTypeValue'
	],
	//=========================================================================
	// вычисляемые данные
	//=========================================================================
	computed: {
		// вычисляем плейсхолдер
		placeholder() {
			if (this.Field.required === true) return this.Field.title + ' *'
			else return this.Field.title
		},
		// генерация ссылки если заданые определенные поля
		generateAfterUrl() {
			if (!this.Field.after_url) return '#'
			if (this.crud === 'options') return this.Field.after_url.replace('%ID%', this.$store.state.user_id)
			if (this.crud === 'user' && this.objID) return this.Field.after_url.replace('%ID%', this.objID)
			return '#'
		},
		// вычисляем ошибку
		fieldError() {
			if (typeof this.Field['_errMsg'] === 'string' && this.Field['_errMsg'].length) return this.Field['_errMsg']
			return false
		},
		// вычисляем видимость текущего поля
		fieldVisible() {
			// частный случай - регистрация нового домена
			if (this.crud === 'domains' && this.action === 'create')
			{
				// поле "group_id"
				if (this.Field['_field_name'] === 'plan_group_id')
				{
					// если группа одна – не рисовать её
					if (this.Field.type === 'list' &&
						this.Field.list && typeof this.Field.list === 'object' && Array.isArray(this.Field.list) &&
						this.Field.list.length === 1)
						return false
				}

				// поле "name" - не рисуем, оно будет отрисовано в составе поля "plan_id"
				if (this.Field['_field_name'] === 'name') return false
			}

			// частный случай
			if (this.crud === 'vds' && this.action === 'create')
			{
				// поля всегдя видимы
				if (this.Field['_field_name'] === 'backup_auto')
					return true
			}

			if (this.Field.type === 'savedPayments')
			{
				if (this.crud === 'paymentauto')
					return true
				else
					return this.Field.list && this.Field.list.length
			}

			return this.Field['_visible']
		},
		isFieldGreyed() {
			if (this.crud === 'vds' && this.action === 'create')
			{
				if (this.Field._field_name === 'backup_auto' && !this.Field._visible)
					return true
			}

			return false
		},
		// стиль для плейсхолдера и лейбла
		fieldLabelStyle() {
			if (this.Field['_is_short'] === true) return 'left: 11px'

			let _style = false
			if (this.Field['readonly'] === true) _style = 'z-index: 1'
			return _style
		},
		fieldPlaceholderStyle() {
			if (this.Field['_is_short'] === true) return 'left: 10px'

			let _style = false
			if (this.Field['readonly'] === true) _style = 'z-index: 1'
			return _style
		},
		fieldPlaceholderVisible() {
			if (this.isUniqueInVds()) return false
			if (this.isUniqueInOperation()) return false
			if (this.isUniqueInCertificate()) return false
			if (this.isUniqueInDomains()) return false

			if (this.Field._field_name === 'role_items') return false
			if (this.Field.type === 'hidden') return false
			if (this.Field.type === 'file') return false
			if (this.Field.type === 'image') return false
			if (this.Field.type === 'simpleButton') return false
			if (this.Field.type === 'urlButton') return false
			if (this.Field.type === 'boolean') return false
			if (this.Field.type === 'radio') return false
			if (this.Field.type === 'passport') return false
			if (this.Field.type === 'address') return false
			if (this.Field.type === 'savedPayments') return false
			if (this.Field.type === 'header') return false
			if (this.Field.type === 'clearText') return false
			if (this.Field.type === 'slider') return false

			return true
		},
		listOptions() {
			return this.curList
		},
		isLatin() {
			if (this.crud === 'certificate' && this.Field['_field_name'] === 'org_address')
				return true

			if (this.Field['validator'] === 'low_name_english' ||
				this.Field['validator'] === 'phis_name_english' ||
				this.Field['validator'] === 'phis_name_english_2' ||
				this.Field['validator'] === 'text_english')
				return true

			return false
		},
		isRussia() {
			if (this.Field['validator'] === 'phis_name_russian' ||
				this.Field['validator'] === 'low_name_russian')
				return true

			return false
		},
		isLatinCapitalize() {
			if (this.crud === 'certificate' &&
				(this.Field['_field_name'] === 'province' ||
				this.Field['_field_name'] === 'city' ||
				this.Field['_field_name'] === 'owner'))
				return true

			if (this.Field['validator'] === 'phis_name_english')
				return true

			return false
		},
		QAURL() {
			return Vue.QAUrl
		},
		planSelectedItem() {
			if (!this.planField || !this.planField.value || !this.planField.list || !this.planField.list.length)
				return null

			let _result = null
			this.planField.list.some(item => {
				if (item && String(item.id) === String(this.planField.value))
				{
					_result = item
					return true
				}
			})

			return _result
		},
		isBackupItemDiscountCost() {
			if (!this.planSelectedItem ||
				!this.planSelectedItem.backup ||
				!('cost' in this.planSelectedItem.backup) ||
				!('full_cost' in this.planSelectedItem.backup) ||
				!('period_name' in this.planSelectedItem.backup) ||
				!this.planSelectedItem.data ||
				!this.planSelectedItem.data.disk ||
				!('value' in this.planSelectedItem.data.disk))
				return false

			let _cost = parseFloat(this.planSelectedItem.backup.cost)
			if (isNaN(_cost)) _cost = 0

			let _fullCost = parseFloat(this.planSelectedItem.backup.full_cost)
			if (isNaN(_fullCost)) _fullCost = 0

			return _fullCost !== _cost
		},
		BackupItemDiscountCost() {
			if (!this.planSelectedItem ||
				!this.planSelectedItem.backup ||
				!('cost' in this.planSelectedItem.backup) ||
				!('full_cost' in this.planSelectedItem.backup) ||
				!('period_name' in this.planSelectedItem.backup) ||
				!this.planSelectedItem.data ||
				!this.planSelectedItem.data.disk ||
				!('value' in this.planSelectedItem.data.disk))
				return ''

			let _cost = parseFloat(this.planSelectedItem.backup.cost)
			if (isNaN(_cost)) _cost = 0
			let _fullCost = parseFloat(this.planSelectedItem.backup.full_cost)
			if (isNaN(_fullCost)) _fullCost = 0
			let _val = parseInt(this.planSelectedItem.data.disk.value, 10)
			if (isNaN(_val)) _val = 0
			// размер диска из параметров только если текущи тариф имеет параметры
			if (this.planSelectedItem.has_params === true &&
				this.planParams &&
				'params[disk]' in this.planParams &&
				!isNaN(this.planParams['params[disk]']) &&
				this.planParams['params[disk]'] > 0)
			{
				_val = parseInt(this.planParams['params[disk]'], 10)
				if (isNaN(_val)) _val = 0
			}

			return this.localeFtc('service/creating_backup_cost <p>{discount}</p> <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>')
				.replace('{cost}', '&nbsp;' + Helper.String2Money(Helper.FormatMoney2(_fullCost * _val, 2)) + ' ' + this.localeFtc('main/ruble'))
				.replace('{discount}', Helper.String2Money(Helper.FormatMoney2(_cost * _val, 2)))
				.replace('{period}', this.localeFtc(this.planSelectedItem.backup.period_name))
				.replace('{size}', _val + ' ' + this.localeFtc(this.planSelectedItem.data.disk.for))
		},
		BackupItemCost() {
			if (!this.planSelectedItem ||
				!this.planSelectedItem.backup ||
				!('cost' in this.planSelectedItem.backup) ||
				!('period_name' in this.planSelectedItem.backup) ||
				!this.planSelectedItem.data ||
				!this.planSelectedItem.data.disk ||
				!('value' in this.planSelectedItem.data.disk))
				return ''

			let _cost = parseFloat(this.planSelectedItem.backup.cost)
			if (isNaN(_cost)) _cost = 0
			let _val = parseInt(this.planSelectedItem.data.disk.value, 10)
			if (isNaN(_val)) _val = 0
			// размер диска из параметров только если текущи тариф имеет параметры
			if (this.planSelectedItem.has_params === true &&
				this.planParams &&
				'params[disk]' in this.planParams &&
				!isNaN(this.planParams['params[disk]']) &&
				this.planParams['params[disk]'] > 0)
			{
				_val = parseInt(this.planParams['params[disk]'], 10)
				if (isNaN(_val)) _val = 0
			}

			return this.localeFtc('service/creating_backup_cost <b>main/ruble</b> / <b>{period}</b> / <b>{size}</b>')
				.replace('{cost}', Helper.String2Money(Helper.FormatMoney2(_cost * _val, 2)))
				.replace('{period}', this.localeFtc(this.planSelectedItem.backup.period_name))
				.replace('{size}', _val + ' ' + this.localeFtc(this.planSelectedItem.data.disk.for))
		},
		BooleanFieldCost() {
			if (!this.Field || !this.Field.period || !('cost' in this.Field))
				return null

			if (this.Field.info)
				return this.localeFtc('plan/cost <b>{cost} main/ruble</b> / <b>{period}</b> (' + this.Field.info + ')')
					.replace('{cost}', this.Field.cost)
					.replace('{period}', this.localeFtc(this.Field.period))
					.toLowerCase()
			else
				return this.localeFtc('plan/cost <b>{cost} main/ruble</b> / <b>{period}</b>')
					.replace('{cost}', this.Field.cost)
					.replace('{period}', this.localeFtc(this.Field.period))
					.toLowerCase()
		},
		isUrlWithQuery() {
			return (this.Field && this.Field.url && this.Field.url.indexOf('q=') > -1)
		},
		isSelectSearchable() {
			// если это поисковый URL - разрешаем искать
			if (this.isUrlWithQuery) return true

			// иначе, разрешаем искать только если итемов больше 15
			if (this.curList.length > 15) return true

			// по умолчанию - поиск запрещен
			return false
		},
		sliderMarks() {
			const answer = []

			if (!this.Field || !('max' in this.Field))
				return answer

			answer.push(1)

			let marksCount = 10
			if (this.$store.state.windowWidth < 1000) marksCount = 8
			if (this.$store.state.windowWidth < 800) marksCount = 4
			if (this.$store.state.windowWidth < 600) marksCount = 2

			if (this.fieldInModal) {
				marksCount = 4
				if (this.$store.state.windowWidth < 600) marksCount = 2
			}

			const delta = Math.ceil(this.Field.max / marksCount)
			for (let i = 0; i < 10; i++) {
				const value = i * delta
				if (value > 1 && value < this.Field.max) {
					answer.push(value)
				}
			}

			answer.push(this.Field.max)

			return answer
		},
		outerDisksPrice() {
			if (!this.Field || !('cost' in this.Field)) return 0

			const _value = parseFloat(this.Field.cost * this.fieldCurValue)
			if (isNaN(_value) || _value < 0) return 0

			return _value
		},
		// значение длины "засеривания" слайдера от начала до минимума
		minRangeWidthStyle() {
			let min = 0
			let minRangeValue = 1
			if ('min' in this.Field)
			{
				minRangeValue = parseFloat(this.Field.min)
				if (isNaN(minRangeValue)) minRangeValue = 1
			}

			let max = 1
			if ('max' in this.Field)
			{
				max = parseFloat(this.Field.max)
				if (isNaN(max) || max === 0) max = 1
			}

			let total = max - min
			if (isNaN(total) || total === 0) total = 1
			let rangeValue = minRangeValue - min

			return 'width: ' + (rangeValue / total * 100.0) + '%'
		}
	},
	//=========================================================================
	// локальные переменные
	//=========================================================================
	data() {
		return {
			// текущее значение элемента
			fieldCurValue: null,

			// включена/выключена анимация
			fieldAnimated: false,

			// в фокусе поле элемента или нет
			fieldFocused: false,

			// форматированный список для LIST
			curList: [],
			// строка поиска по списку - если есть флаг
			searchText: '',

			// значение для LIST
			listValue: null,
			// блок врапер
			$listTag: null,
			statusListRequestResult: '',
			statusListRequestProcess: '',
			// DOM-блок со списком
			$ulBlock: null,
			// DOM-блок с ошибкой поля
			$errorBlock: null,
			// DOM-блок с подсказкой
			$tooltipBlock: null,

			// в закрытии смотрим - выбрали дату или нет
			isDateSelected: false,

			// таймер для ожидания ввода клавиш для поля с типом "text"
			textInputTimer: null,

			// таймер для ожидания ввода клавиш для поля поиска в поле с типом "list"
			serachInputTimer: null,

			// большая подсказка над полем
			topHint: false,

			// большая подсказка под полем
			bottomHint: false,

			// большая подсказка справа от поля
			rightHint: false,

			// подсказка вместо поля
			insteadFieldHint: false,

			// результирующий массив поиска в QA
			qaResult: false,

			// фиксированая часть DNS-записи
			dnsFixedValue: '',

			// таймер ошибки для чебокса
			timerBooleanFieldError: null,

			// параметры поля
			params: null,

			// значение в текстовом поле для внешнего диска
			outerDiskValue: 0,
			outerDiskError: '',

			// скрытие/показ нового пароля
			passwordIsShown: true
		}
	},
	//=========================================================================
	// обработчик: компонент примонтирован в DOM
	//=========================================================================
	created() {
		// получаем верхную (и нижнюю) подсказку
		this.getTopHint()

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// передаем данные
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (this.Field.value !== undefined && this.Field.value !== null)
		{
			// если было задано значение по умолчанию - запоминаем в текущем значении
			this.fieldCurValue = this.Field.value
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// TEXT
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (this.Field.type === 'text' || this.Field.type === 'integer' || this.Field.type === 'money' || this.Field.type === 'float')
		{
			if (this.value !== undefined && this.value !== null) this.fieldCurValue = this.value

			if (this.crud === 'dns-records' && this.Field['_field_name'] === 'host' && !this.Field.readonly)
			{
				this.Field['_emptyValue'] = ''
				this.Field['_oldValue'] = ''
				this.Field['value'] = ''
				this.fieldCurValue = ''
				this.dnsFixedValue = this.value
			}
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// DATE
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (this.Field.type === 'date')
		{
			if (this.Field.format)
				// если задан еще и формат
				this.fieldCurValue = this.formater_FormatedStrDate2Date(this.Field.value, this.Field.format)
			else
				// без формата
				this.fieldCurValue = this.formater_StrDate2Date(this.Field.value)
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// DATETIME
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (this.Field.type === 'datetime')
		{
			if (!this.fieldCurValue) this.fieldCurValue = null
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// SLIDER
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (this.Field.type === 'slider')
		{
			if (!('value' in this.Field)) {
				if ('min' in this.Field) {
					this.Field['_emptyValue'] = this.Field.min
					this.Field['_oldValue'] = this.Field.min
					this.Field['value'] = this.Field.min
					this.fieldCurValue = this.Field.min
				}
			} else {
				this.Field['_emptyValue'] = this.Field.value
				this.Field['_oldValue'] = this.Field.value
				this.fieldCurValue = this.Field.value
			}

			this.outerDiskValue = this.fieldCurValue
			this.outerDiskError = ''
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// BOOLEAN
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (this.Field.type === 'boolean')
		{
			this.fieldCurValue = Helper.normalizeBooleanValue(this.fieldCurValue)

			// если задано значение в sessionStore
			if (this.Field._storeValue)
			{
				// частные случаи
				if (this.crud === 'disks' && this.Field._storeValue.field === 'options' && 'value' in this.Field._storeValue)
				{
					this.fieldCurValue = Helper.normalizeBooleanValue(this.Field._storeValue.value)
					// сообщаем родителям
					this.$emit('input', this.fieldCurValue)
					return
				}
			}
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// LIST
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		if (this.Field.type === 'list')
		{
			// признак установки значения
			let _valueDone = false
			// если задано значение - запомним
			if (this.Field.value !== null && this.Field.value !== undefined)
			{
				_valueDone = true
				// если значение - это массив (мультиселект)
				if (Array.isArray(this.Field.value))
				{
					// обнулим текущее значение
					this.listValue = []
					this.fieldCurValue = []

					// частный случай
					if (this.crud === 'user' && this.Field._field_name === 'role_items' && this.Field.value.length)
						this.fieldCurValue = this.Field.value

					// если задан список
					if (this.Field.list)
					{
						this.Field.value.forEach(item => {
							for (let k in this.Field.list)
							{
								if (this.Field.list[k]['id'] === item)
								{
									this.listValue.push({
										'id': item,
										'name': this.localeFtc(this.Field.list[k]['name'])
									})
									this.fieldCurValue.push(item)
									break
								}
							}
						})
					}
					// список не задан - значит в поле "value" уже передано значение
					else
					{
						// копируем значение
						this.Field.value.forEach(item => {
							if (item && typeof item === 'object' && 'id' in item && 'name' in item)
							{
								this.listValue.push({
									'id': String(item['id']),
									'name': this.localeFtc(item['name']),
									'archive': item['archive'],
									'status': item['status'],
									'max': item['max'],
									'min': item['min'],
									'type': item['type']
								})
								this.fieldCurValue.push(String(item['id']))
							}
							else
							{
								this.listValue.push(String(item))
								this.fieldCurValue.push(String(item))
							}
						})
					}
				}
				// если значение - это объект
				else if (typeof this.Field.value === 'object')
				{
					// метка
					_valueDone = true
					// обнулим текущее значение
					this.listValue = []
					this.fieldCurValue = []
					// соберем все значения
					for (let _o in this.Field.value)
					{
						this.listValue.push({
							'id': String(_o),
							'name': this.localeFtc(this.Field.value[_o])
						})
						this.fieldCurValue.push(String(_o))
					}
				}
				else
				{
					// это заданное одиночное значение
					if (this.Field.value === '')
					{
						if (this.crud === 'datacenter')
						{
							this.listValue = { 'id': 'noValue' }
						}
						else this.listValue = { 'id': 'emptyValue', 'name': ' ' }
					}
					else
					{
						this.listValue = { 'id': String(this.Field.value) }
						// если сразу задано наименование значения
						if (this.Field['__valueName'])
							this.listValue = { 'id': String(this.Field.value), 'name': this.localeFtc(this.Field['__valueName']) }
						// если сразу задано наименование значения прямо с сервера
						if (this.Field['text'])
							this.listValue = { 'id': String(this.Field.value), 'name': this.localeFtc(this.Field['text']) }
					}

					this.fieldCurValue = this.listValue['id']
				}
			}
			else
			{
				// если это мультиселект
				if (this.Field.multiselect) this.listValue = []
				// это выбор одного значения
				else this.listValue = {}
			}

			// если задан список
			if (this.Field.list)
			{
				// если он сразу задан в виде массива
				if (Array.isArray(this.Field.list))
				{
					// приведем к нужному виду
					this.Field.list.forEach((item) => {
						if (item) {
							// проверка на заданный доступ
							let _access = true
							if ('access' in item) _access = Helper.normalizeBooleanValue(item['access'])
							// заносим в массив только если есть доступ
							if (_access)
							{
								this.curList.push({
									'id': String(item.id),
									'name': this.localeFtc(item.name),
									'archive': item['archive'],
									'status': item['status'],
									'max': item['max'],
									'min': item['min'],
									'type': item['type'],
									'active': this.activeItem(item)
								})
								// если это текущее значение
								if (this.listValue['id'] === String(item.id)) this.listValue['name'] = this.localeFtc(item.name)
								// частные случаи - значение "Не выбран"
								if (this.crud === 'datacenter' && this.listValue['id'] === 'noValue' && String(item.id).trim() === '') this.listValue['name'] = this.localeFtc(item.name)
							}
						}
					})
				}
				else
				{
					// задан в виде объекта - конвертируем в массив
					for (let _id in this.Field.list)
					{
						// заносим в массив
						if (_id === '')
						{
							// частные случаи пустых значений
							if (this.crud === 'datacenter')
							{
								this.curList.push({
									'id': 'noValue',
									'name': this.localeFtc(this.Field.list[_id])
								})
							}
							// общий случай для пустых значений
							else
							{
								this.curList.push({
									'id': 'emptyValue',
									'name': ' '
								})
							}
						}
						else
						{
							this.curList.push({
								'id': String(_id),
								'name': this.localeFtc(this.Field.list[_id])
							})
						}
						// если это текущее значение
						if (this.listValue['id'] === String(_id)) this.listValue['name'] = Helper.localeFtc(this.Field.list[_id])
						// частные случаи
						if (this.crud === 'datacenter' && this.listValue['id'] === 'noValue' && _id === '') this.listValue['name'] = Helper.localeFtc(this.Field.list[_id])
					}
				}
			}

			// если задано значение в sessionStore
			if (this.Field._storeValue)
			{
				// частные случаи
				if (this.Field._storeValue.field === 'account_id' && this.Field._storeValue.value && this.Field._storeValue.name)
				{
					let _id = String(this.Field._storeValue.value)
					this.listValue = { 'id': _id, 'name': this.Field._storeValue.name }
					this.fieldCurValue = _id
					_valueDone = true
					// сообщаем родителям
					this.$emit('input', this.fieldCurValue)
					return
				}
			}

			// если до сих пор нет значения
			if (!_valueDone)
			{
				// это выбор одного статического значения
				if (!this.Field.multiselect && !this.Field.url)
				{
					// поставим первое значение из списка
					if (this.curList.length)
					{
						this.listValue = this.curList[0]
						this.fieldCurValue = this.listValue['id']
						// если это специальное пустое значение
						if (this.fieldCurValue === 'emptyValue')
						{
							this.fieldCurValue = ''
							this.listValue = {}
						}
						else if (this.fieldCurValue === 'noValue')
						{
							this.fieldCurValue = ''
						}
						else if (
							//(this.crud === 'operation' && this.Field['_field_name'] === 'payment' && this.$store.state.user_type === 'client') ||
							(this.crud === 'vds' && this.Field['_field_name'] === 'template_id' && this.action === 'create')
						)
						{
							// обнуление значения
							this.listValue = null
							this.fieldCurValue = null
						}

						// сообщаем родителям
						this.$emit('input', this.fieldCurValue)
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// частные случаи
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// создание/редактирование account
			if (this.crud === 'account' && this.Field._field_name === 'partner_id')
			{
				if (this.Field.value === undefined || this.Field.value === null || this.Field.value === 0 || String(this.Field.value).trim() === '')
				{
					this.listValue = { 'id': 'zeroValue', 'name': this.Field.text ? this.localeFtc(this.Field.text) : this.localeFtc('main/nobody') }
					this.fieldCurValue = 0
					// сообщаем родителям
					this.$emit('input', this.fieldCurValue)
				}
				else
				{
					this.listValue = { 'id': this.Field.value, 'name': this.Field.text ? this.localeFtc(this.Field.text) : this.localeFtc('main/nobody') }
					this.fieldCurValue = this.Field.value
				}
			}

			// создание/редактирование operation
			/* опять убрали это 2021-03-03
			if (this.crud === 'operation' && this.action === 'create' && this.Field._field_name === 'status')
			{
				// если задан список - ищем значение "status_paid"
				if (this.Field['list'])
				{
					let _val = false
					for (let o in this.Field['list'])
					{
						if (this.Field['list'][o].indexOf('status_paid') >= 0)
						{
							_val = o
							break
						}
					}

					// если нашли такое - ставим его по умолчанию
					if (_val)
					{
						this.listValue = { 'id': _val, 'name': this.localeFtc(this.Field['list'][_val]) }
						this.fieldCurValue = _val
						// сообщаем родителям
						this.$emit('input', this.fieldCurValue)
					}
				}
			}
			*/

			// создание/редактирование department
			if (this.crud === 'department' && this.Field._field_name === 'manager')
			{
				// если значение уже задано
				if (this.fieldCurValue)
				{
					// ищем наименование значения
					if (this.Field['text']) this.listValue['name'] = this.localeFtc(this.Field['text'])
					else this.listValue['name'] = this.fieldCurValue
				}
			}

			// плательщик юр.лицо у клиентов
			if (this.crud === 'operation' && (this.action === 'select' || this.action === 'create') && this.Field._field_name === 'payer')
			{
				// делаем изменения типа только если список пуст
				if (!this.Field.list || !this.Field.list.length)
				{
					if (this.$store.state.user_type !== 'admin')
					{
						this.Field.type = 'urlButton'
						this.Field.urlLink = '/payer/create'
						this.Field.urlText = 'payer/create_title'
					}
				}
			}

			// если это поле меток тикетов
			if (this.Field._field_name === 'set_label')
				this.$nextTick(() => { this.ticketLabelSelected($(this.$el)) })
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},
	//=========================================================================
	// компонент успешно примонтирован в DOM
	//=========================================================================
	mounted() {
		// подписка на событие - "crop"
		EventBus.$on('w5-crop-data', this.getCropData)
		// подписка на событие по установлению значения
		EventBus.$on('w5-set-text-field-value', this.setTextValueByEvent)
		EventBus.$on('w5-set-date-field-value', this.setDateValueByEvent)
		EventBus.$on('w5-set-list-field-value', this.setListValueByEvent)
		EventBus.$on('w5-set-bool-field-value', this.setBoolValueByEvent)
		// подписка на событие - начальные данные формы
		EventBus.$on('w5-init-form-data', this.initOldValue)
		// восстановили данные из sessionStorage из блока приложения
		EventBus.$on('w5-field-data-from-block', this.fromBlock)
		// генерация события "blur" для другого поля
		EventBus.$on('w5-field-emit-blur', this.emitBlurEvent)
		// транслитерация
		EventBus.$on('w5-transliterate', this.transliterate)
		// запрос значения
		EventBus.$on('w5-get-field-value', this.emitFieldValue)
		// обнуление значения списка
		EventBus.$on('w5-clear-list-field', this.clearListField)
		// установки ошибки для поля
		EventBus.$on('w5-set-field-error', this.setFieldError)
		// пересчет размеров и координат блоков поля в диалоге
		EventBus.$on('w5-recount-field-blocks', this.recountBlocksInModal)
		// анимация поля
		EventBus.$on('w5-animate-field', this.animationFieldRequested)
		// установка ошибки в поле
		EventBus.$on('w5-set-error-message', this.setErrorToField)
		// обработчик клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		// поиск в QA при создании тикетов
		if ((this.crud === 'ticket' && this.action === 'create' && this.Field._field_name === 'subject') ||
			(this.crud === 'qa' && this.action === 'list' && this.Field._field_name === 'qaSearch'))
			EventBus.$on('form-ticket-serach-result', this.qaSearchResult)

		// если это список, и требуется перенести DOM-блок со списком "ul"
		if (this.Field.type === 'list' && this.listBlockToOut)
		{
			// если блок еще остался - удалим его
			if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.remove()

			// найдем врапер текущего поля
			let $component = $(this.$el)
			if (!$component.length) return

			// найдем блок со списком
			this.$ulBlock = $component.find('ul:first').parent()
			if (!this.$ulBlock.length) return

			// пропишем жестко стиль блоку
			let _css = {
				'position': 'absolute',
				'display': 'none',
				'width': this.removeRightPadding ? '100%' : 'calc(100% - 10px)',
				'z-index': 99
			}
			// хватает ли места внизу
			let hasEnoughSpace = this.$el.getBoundingClientRect().top + 300 < window.innerHeight
			if (!hasEnoughSpace)
			{
				$component.addClass('multiselect--above')
				_css['margin-bottom'] = '-10px'
			}

			// частный случай
			if (this.crud === 'vds') $component.removeClass('multiselect--above')

			this.$ulBlock.css(_css)

			// обработчик клика общий
			$component.on('mousedown', event => {
				// если кликнули по уже активному компоненту
				if (event.target.nodeName === 'DIV' && event.target.className.indexOf('multiselect__tags__focused') > -1)
				{
					this.$children[0].deactivate()
					return false
				}
			})

			// переместим его наружу (в конец врапера)
			if (this.listBlockToOut === true)
				this.$ulBlock.detach().appendTo($component)
			else
				this.$ulBlock.detach().appendTo($('body'))
		}

		// если поле в модальном диалоге
		if (this.fieldInModal)
		{
			// найдем врапер текущего поля
			let $component = $(this.$el)
			if ($component.length)
			{
				// 1. блок с ошибкой
				// если блок еще остался - удалим его
				if (this.$errorBlock && this.$errorBlock.length) this.$errorBlock.remove()
				// ищем по новой
				this.$errorBlock = $component.find('div.w5-alert-valid:first')
				// переносим
				if (this.$errorBlock && this.$errorBlock.length)
					this.$errorBlock.detach().appendTo($('body'))

				// 2. блок с подсказкой
				// если блок еще остался - удалим его
				if (this.$tooltipBlock && this.$tooltipBlock.length) this.$tooltipBlock.remove()
				// ищем по новой
				this.$tooltipBlock = $component.find('div.w5-tooltip-wrapper:first')
				// переносим
				if (this.$tooltipBlock && this.$tooltipBlock.length)
					this.$tooltipBlock.detach().appendTo($('body'))
			}

			this.$nextTick(() => this.recountBlocksInModal())
		}

		// частный случай - калькулятор стоимости услуг
		if (this.crud === 'service' && this.action === 'calc' && this.Field._field_name === 'period')
		{
			let $component = $(this.$el)
			if ($component && $component.length)
				$component.addClass('multiselect--above')
		}

		// частный случай - слайдер
		if (this.Field.type === 'slider') {
			this.setSliderHandlers()
		}

		// если это список - пробуем покрасить итемы списка в зависимости от полей типа "active"
		if (this.Field.type === 'list' && this.Field['_visible'] && !this.Field['readonly'])
			this.setColorOfItems()

		// специальные преобразования (например метки тикетов)
		this.specialForm()
	},
	//=========================================================================
	// изменился контент
	//=========================================================================
	updated() {
		// частный случай - слайдер
		if (this.Field.type === 'slider') {
			this.setSliderHandlers()
		}

		// если это список - пробуем покрасить итемы списка в зависимости от полей типа "active"
		if (this.Field.type === 'list' && this.Field['_visible'] && !this.Field['readonly'])
			this.setColorOfItems()
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-crop-data', this.getCropData)
		EventBus.$off('w5-set-text-field-value', this.setTextValueByEvent)
		EventBus.$off('w5-set-date-field-value', this.setDateValueByEvent)
		EventBus.$off('w5-set-list-field-value', this.setListValueByEvent)
		EventBus.$off('w5-set-bool-field-value', this.setBoolValueByEvent)
		EventBus.$off('w5-init-form-data', this.initOldValue)
		EventBus.$off('w5-field-data-from-block', this.fromBlock)
		EventBus.$off('w5-field-emit-blur', this.emitBlurEvent)
		EventBus.$off('w5-transliterate', this.transliterate)
		EventBus.$off('w5-get-field-value', this.emitFieldValue)
		EventBus.$off('w5-clear-list-field', this.clearListField)
		EventBus.$off('w5-set-field-error', this.setFieldError)
		EventBus.$off('w5-recount-field-blocks', this.recountBlocksInModal)
		EventBus.$off('w5-animate-field', this.animationFieldRequested)
		EventBus.$off('w5-set-error-message', this.setErrorToField)

		document.removeEventListener('keydown', this.keyDownHandler)

		if ((this.crud === 'ticket' && this.action === 'create' && this.Field._field_name === 'subject') ||
			(this.crud === 'qa' && this.action === 'list' && this.Field._field_name === 'qaSearch'))
			EventBus.$off('form-ticket-serach-result', this.qaSearchResult)

		if (this.textInputTimer) clearTimeout(this.textInputTimer)
		if (this.timerBooleanFieldError) clearTimeout(this.timerBooleanFieldError)

		if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.remove()
		if (this.$errorBlock && this.$errorBlock.length) this.$errorBlock.remove()
		if (this.$tooltipBlock && this.$tooltipBlock.length) this.$tooltipBlock.remove()
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// преобразует шаблон хинта в HTML
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		linkHintHtml(data) {
			if (!data || !data.link || !data.title) return ''

			const title = this.localeFtc(data.title)
			let begin = title.indexOf('[URL]')
			let end = title.indexOf('[/URL]')
			let answer = Helper.escapeHtml(title)

			if (begin > -1 && end > -1)
			{
				answer = answer
					.replace('[URL]', '<a href="' + data.link + '" target="_blank" style="margin: 0">')
					.replace('[/URL]', '</a>')
			}

			return answer
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// уникальные компоненты
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// список тарифных планов или шаблонов в создании VDS
		isUniqueInVds() {
			if (this.crud === 'vds' &&
				(this.Field['_field_name'] === 'plan_group_id' || this.Field['_field_name'] === 'plan_id' || this.Field['_field_name'] === 'template_id' || this.Field['_field_name'] === 'datacenter_id'))
			{
				return true
			}

			if (this.crud === 'disks' && (this.Field['_field_name'] === 'datacenter_id' || this.Field['_field_name'] === 'backup_id'))
			{
				return true
			}

			return false
		},
		// список способов оплат в создании операции клиентом
		isUniqueInOperation() {
			if (this.crud === 'operation' && this.Field['_field_name'] === 'payment')
			{
				if (this.$store.state.user_type === 'admin')
				{
					if (this.action === 'select' || this.action === 'pay') return true
					return false
				}
				return true
			}

			return false
		},
		// список тарифов для SSL
		isUniqueInCertificate() {
			if (this.crud === 'certificate' && this.Field['_field_name'] === 'plan_id') return true
			return false
		},
		// список тарифов для Domains
		isUniqueInDomains() {
			if (this.crud === 'domains' && this.Field['_field_name'] === 'plan_id') return true
			return false
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// пустое значение или нет
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		notEmpty(value) {
			// datetime всегда заполнен
			if (this.Field['type'] === 'datetime') return true
			// passport всегда заполнен
			if (this.Field['type'] === 'passport') return true
			// пустое значение
			if (value === undefined || value === null) return false
			// частный случай непустого значения
			if (this.crud === 'datacenter' && String(value) === '' && this.Field['_field_name'] !== 'fastSearch') return true
			if (this.crud === 'account' && String(value) === '0') return true
			// пустые значения для полей "List"
			if (this.Field['type'] === 'list')
			{
				if (!value || value === '' || value === 'emptyValue') return false
				if (this.crud === 'servicetype' && value === 'none') return false
			}
			// person
			if (this.crud === 'person' && (this.Field._field_name === 'data[ru_phis][birth_date]' || this.Field._field_name === 'data[birth_date]'))
			{
				if (!value) return false
				else if (value === 'not-date') return true
				else return true
			}
			// другие пустые значения
			if (String(value) === '') return false
			// не пустое
			return true
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// стиль для textarea
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		textAreaStyle() {
			if (this.Field._field_name === 'data' && this.crud === 'sshkey')
			{
				if (this.fieldInModal) return 'height: 340px'
				else return 'height: 240px'
			}
			if (this.Field._field_name === 'content' && this.crud === 'ticketmessage') return 'height: 100px'
			return false
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// поменялось поле
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onChange() {
			// если это текстовое поле - событие ввода с задержкой
			if (this.Field.type === 'text')
			{
				if (this.isLatin)
					this.fieldCurValue = Helper.onlyLatin(this.fieldCurValue)
				else if (this.isLatinCapitalize)
					this.fieldCurValue = Helper.FirstSymbolToUpperAndLatin(this.fieldCurValue)
				else if (this.isRussia)
					this.fieldCurValue = Helper.onlyRussia(this.fieldCurValue)
			}
			// slider
			if (this.Field.type === 'slider') {
				this.Field._errMsg = ''

				const _min = 'min' in this.Field ? this.Field.min : 0
				if (this.fieldCurValue < _min) {
					this.fieldCurValue = _min

					if (this.$refs &&
						this.$refs[this.Field._field_name] &&
						'setValue' in this.$refs[this.Field._field_name]) {
						this.$refs[this.Field._field_name].setValue(this.fieldCurValue)
					}
				}

				this.outerDiskValue = this.fieldCurValue
				this.outerDiskError = ''
			}
			// если это в создании VDS
			if (this.crud === 'vds' &&
				(this.Field._field_name === 'plan_id' ||
				this.Field._field_name === 'template_id' ||
				this.Field._field_name === 'backup_id' ||
				this.Field._field_name === 'iso_id'))
			{
				// чистим каждый раз ошибку
				this.Field._errMsg = ''
				// генерируем событие изменения плана
				if (this.Field._field_name === 'plan_id')
				{
					let found = null
					if (this.Field && this.Field.list && this.Field.list.length)
					{
						this.Field.list.some(plan => {
							if (plan && String(plan.id) === String(this.fieldCurValue))
							{
								found = Object.assign({}, plan)
								return true
							}
						})
					}

					EventBus.$emit('w5-new-vds-plan-notice', {
						id: this.fieldCurValue,
						plan: found
					})
				}
			}

			// если это создание внешнего диска
			if (this.crud === 'disks' && this.action === 'create' && this.Field._field_name === 'backup_id')
			{
				// чистим каждый раз ошибку
				this.Field._errMsg = ''
				// если обнулили выбор
				if (this.fieldCurValue === '' || this.fieldCurValue === null || this.fieldCurValue === undefined)
				{
					this.fieldCurValue = null
					this.listValue = null
				}
			}

			// сообщим родителям
			this.$emit('input', this.fieldCurValue)
			this.$emit('valueChanged', this.Field)

			// если это строка быстрого поиска - генерируем событие изменения строки поиска
			if (this.Field.type === 'text' && this.Field._field_name === 'fastSearch')
				this.$emit('fastSearchInput', this.fieldCurValue)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// поменялись параметры поля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onParams(params) {
			if (!params || !params['01']) return

			let _newParams = {}
			for (let idx in params)
			{
				let data = params[idx]
				if (!data || !data.__prop) continue

				if (data.type === 'boolean')
				{
					_newParams['params[' + data.__prop + ']'] = data.value ? 1 : 0
				}
				else
				{
					_newParams['params[' + data.__prop + ']'] = data.value
				}
			}

			this.params = _newParams
			this.$emit('params', _newParams)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// поменялась группа
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onGroupChanged(newGroup) {
			// передаем дальше на верх
			this.$emit('groupChanged', newGroup)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// поменялось наименование домена
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onDomainName(value) {
			// чистим каждый раз ошибку
			this.Field._errMsg = ''
			// передаем дальше наверх
			this.$emit('domainName', value)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// запрос на копирование адреса в почтовый адрес
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		copyAddress(data) {
			let _fieldToCopy = ''

			if (this.crud === 'person')
			{
				_fieldToCopy = this.Field._field_name
					.replace('residence', 'p_addr')
					.replace('address_r', 'p_addr')
			}

			if (this.crud === 'payer')
			{
				_fieldToCopy = this.Field._field_name
					.replace('address', 'post_addr')
			}

			if (!_fieldToCopy) return

			EventBus.$emit('w5-copy-address-field-value', {
				name: _fieldToCopy,
				fields: data
			})
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// ошибка в дате
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onError(text) {
			if (text && this.Field._errMsg !== text)
				this.Field._errMsg = text
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// поменялись начальные значения у поля с тарифами
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onStartData(value) {
			if (!this.Field['_emptyValue'])
				this.Field['_emptyValue'] = value

			if (!this.Field['_oldValue'])
				this.Field['_oldValue'] = value
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// успешно закончилась закачка файла
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onUploadFinished() {
			// сообщим родителям
			this.$emit('uploadFinished')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// успешно закончилась закачка ISO
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onIsoUploadFinished() {
			// сообщим родителям
			this.$emit('isoUploadFinished')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// прервали закачку ISO
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onIsoUploadCanceled() {
			this.$emit('isoUploadCanceled')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// ошибка при закачке ISO
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onIsoUploadError(text) {
			this.$emit('isoUploadError', text)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// расчет координат и размеров доп.блоков в модальных диалогах
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		recountBlocksInModal() {
			if (this.fieldInModal)
			{
				// получим JQ-блок поля
				let $component = $(this.$el)
				if ($component && $component.length)
				{
					// расчитаем координаты блока
					let _elHeight = $component.height()
					let _elOffset = $component.offset()
					let _elWidth = $component.width()
					if (_elWidth <= 0) _elWidth = '100%'

					// 1. блок ошибки
					if (this.$errorBlock && this.$errorBlock.length)
					{
						let _css = {
							top: _elOffset.top + _elHeight + 10,
							left: _elOffset.left,
							maxWidth: _elWidth,
							zIndex: 9998
						}
						if (this.$store.state.windowWidth <= 767)
							_css.width = _elWidth

						this.$errorBlock.css(_css)
					}

					// 2. блок подсказки
					if (this.$tooltipBlock && this.$tooltipBlock.length)
					{
						let _css = {
							position: 'absolute',
							top: _elOffset.top + _elHeight + 10,
							left: _elOffset.left,
							maxWidth: _elWidth,
							zIndex: 9998
						}
						if (this.$store.state.windowWidth <= 767)
							_css.width = _elWidth

						this.$tooltipBlock.css(_css)
					}
				}
			}
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// фокус на поле элемента
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		fieldFocus(e) {
			// костыль для отключения автозаполнения
			// для быстрого поиска убираем readonly аттрибут при фокусе
			if (this.Field._field_name === 'fastSearch' &&
				this.Field.type === 'text' &&
				e && e.target && e.target.removeAttribute)
			{
				e.target.removeAttribute('readonly')
			}
			// если поле в модальном диалоге и найден блок с ошибкой
			this.recountBlocksInModal()
			// при первом фокусе - включаем анимацию (по умолчанию она отключена)
			this.fieldAnimated = true
			// метим элемент как элемент с фокусом
			this.fieldFocused = true
			// сообщаем родителям
			this.$emit('focus')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// эмуляция фокуса
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		emitFocus() {
			this.$emit('focus')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// эмуляция блюра
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		emitBlure(field) {
			// если не указано поле по которому произошло событие - будет текущее
			if (!field)
				return this.$emit('blur')
			else
				EventBus.$emit('w5-field-emit-blur', field)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// просят сгенерировать событие blur для поля field
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		emitBlurEvent(field) {
			if (this.Field['_field_name'] === field)
				this.$emit('blur')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// просят установить транслитерированное значение
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// реализация транслита с учетом регистра букв
		__transliterate(str) {
			if (!str) return str
			str = String(str)
			if (!str.length) return str

			// https://yandex.ru/support/nmaps/app_transliteration.html
			let srcLetter = {
				'А': 'A',
				'Б': 'B',
				'В': 'V',
				'Г': 'G',
				'Д': 'D',
				'Е': 'E',
				'Ё': 'Yo',
				'Ж': 'Zh',
				'З': 'Z',
				'И': 'I',
				'Й': 'Y',
				'К': 'K',
				'Л': 'L',
				'М': 'M',
				'Н': 'N',
				'О': 'O',
				'П': 'P',
				'Р': 'R',
				'С': 'S',
				'Т': 'T',
				'У': 'U',
				'Ф': 'F',
				'Х': 'Kh',
				'Ц': 'Ts',
				'Ч': 'Ch',
				'Ш': 'Sh',
				'Щ': 'Sch',
				'Ь': '',
				'Э': 'E',
				'Ю': 'Yu',
				'Я': 'Ya'
			}

			let answer = ''
			let letters = str.split('')
			for (let i = 0; i < letters.length; i++)
			{
				// буква в слове
				let ch = String(letters[i]).trim().toUpperCase()

				// 'Ь'
				if (ch === 'Ь')
				{
					continue
				}

				// если есть ее транса
				if (srcLetter[ch])
				{
					// если это низкий регистр
					if (ch !== String(letters[i]).trim())
						answer += srcLetter[ch].toLowerCase()
					// если это верхний регистр
					else
					{
						// если это последняя буква
						if (i === (letters.length - 1))
						{
							// весь трансилит будет заглавный
							answer += srcLetter[ch].toUpperCase()
						}
						// есть еще буква
						else
						{
							// следующая буква
							let nextCh = String(letters[i + 1]).trim().toUpperCase()
							// если есть ее транса
							if (srcLetter[nextCh])
							{
								// если это низкий регистр
								if (nextCh !== String(letters[i + 1]).trim())
									answer += srcLetter[ch]
								// если это верхний регистр
								else
									answer += srcLetter[ch].toUpperCase()
							}
							// 'Ъ'
							else if (nextCh === 'Ъ')
							{
								// если это низкий регистр
								if (letters[i + 1] === 'ъ')
									answer += srcLetter[ch]
								// если это верхний регистр
								else
									answer += srcLetter[ch].toUpperCase()
							}
							// 'Ы'
							else if (nextCh === 'Ы')
							{
								// если это низкий регистр
								if (letters[i + 1] === 'ы')
									answer += srcLetter[ch]
								// если это верхний регистр
								else
									answer += srcLetter[ch].toUpperCase()
							}
							// иное
							else answer += srcLetter[ch].toUpperCase()
						}
					}
				}
				// 'Ъ'
				else if (ch === 'Ъ')
				{
					// не пишется, кроме: ъе → ye
					// если не последняя буква и следующая буква 'Е'
					if (i < (letters.length - 1) && (letters[i + 1] === 'Е' || letters[i + 1] === 'е'))
					{
						if (letters[i] === 'ъ')
							answer += 'y'
						else
							answer += 'Y'
					}
				}
				// 'Ы'
				else if (ch === 'Ы')
				{
					// 'Y как исключение, в окончаниях ый → iy (аналогично окончанию ий → iy)',
					// если не последняя буква и следующая буква 'Й'
					if (i < (letters.length - 1) && (letters[i + 1] === 'Й' || letters[i + 1] === 'й'))
					{
						if (letters[i] === 'ы')
							answer += 'i'
						else
							answer += 'I'
					}
					else
					{
						if (letters[i] === 'ы')
							answer += 'y'
						else
							answer += 'Y'
					}
				}
				// иное
				else answer += letters[i]
			}

			return answer
		},

		transliterate(data) {
			if (!data || !data.field || !data.value) return

			if (this.Field['_field_name'] !== data.field) return

			if (data.what === 'fio')
			{
				let _fio = String(data.value).split(' ')
				let _forTrans = ''
				if (_fio.length === 1)
				{
					_forTrans = Helper.toTrimString(data.value)
				}
				else if (_fio.length === 2)
				{
					_forTrans = (Helper.toTrimString(_fio[1]) + ' ' + Helper.toTrimString(_fio[0])).trim()
				}
				else if (_fio.length >= 3)
				{
					let _part2 = Helper.toTrimString(_fio[2])
					_forTrans = (Helper.toTrimString(_fio[1]) + (_part2 && _part2.length ? ' ' + _part2[0] + ' ' : ' ') + Helper.toTrimString(_fio[0])).trim()
				}

				this.Field.value = this.__transliterate(_forTrans)
				this.fieldCurValue = this.Field.value
				return
			}

			this.Field.value = this.__transliterate(data.value)
			this.fieldCurValue = this.Field.value
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// запросили значение поля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		emitFieldValue(fieldName) {
			if (this.Field._field_name !== fieldName) return
			EventBus.$emit('w5-get-field-value-answer', {
				name: this.Field._field_name,
				value: this.fieldCurValue
			})
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// убрали фокус с поля элемента
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		fieldBlur(e) {
			// метим элемент как элемент без фокуса, анимация остается включенной
			this.fieldFocused = false
			// сообщаем родителям
			this.$emit('blur')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// возвращает верхную подсказку: верхние подсказки - это все частные случаи
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		getTopHint() {
			// значение по умолчанию
			this.topHint = false
			this.bottomHint = false
			this.rightHint = false
			this.insteadFieldHint = false

			// если указано явно
			if (this.Field.warning) this.topHint = this.Field.warning

			// частные случаи
			if (this.crud === 'twofa' && this.Field.hint) this.topHint = this.Field.hint
			if (this.crud === 'operation' && this.Field._field_name === 'save' && this.Field.hint)
			{
				this.bottomHint = this.Field.hint
				// что бы не показывало стандартную подсказку
				this.Field.hint = ''
			}
			if (this.crud === 'paymentauto' && this.Field._field_name === 'saved_id' && (this.Field.hint || this.Field.__hint))
			{
				if (this.Field && this.Field.list && this.Field.list.length)
					this.bottomHint = this.Field.hint || this.Field.__hint
				else
					this.insteadFieldHint = this.Field.hint || this.Field.__hint

				if (this.Field.hint) this.Field.__hint = this.Field.hint
				this.Field.hint = ''
			}
			if (this.crud === 'paymentauto' && this.Field.type === 'money' && this.Field.hint)
			{
				this.rightHint = this.Field.hint
				this.Field.hint = ''
			}
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// TEXT: клик по кнопке очистки поля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		clearButtonClick(e) {
			this.fieldCurValue = ''
			this.$emit('event_ClearButtonClicked')
			this.$refs[this.Field._field_name].focus()
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// TEXT: клик по кнопке поиска
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		searchButtonClick(e) {
			this.$emit('event_SearchButtonClicked')
			this.$refs[this.Field._field_name].focus()
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// PASSWORD: генерация пароля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		generatePasswordHandler() {
			this.fieldCurValue = Helper.generatePassword()
			this.$refs[this.Field._field_name].focus()
			this.$emit('input', this.fieldCurValue)
			this.$emit('valueChanged', this.Field)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// PASSWORD: скрытие/показ пароля с изменением типа поля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		togglePasswordVisibility() {
			this.passwordIsShown = !this.passwordIsShown
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// BOOLEAN: клик по лейблу, поэтому меняем значение сами
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		clickBooleanLabel(e) {
			// если поле задизаблено - ничего не делаем
			if (this.Field.readonly === true) return
			// эмуляция фокуса
			this.$emit('focus')
			// если это 2FA
			if (this.crud === 'options' && this.Field._field_name === 'twofa')
			{
				this.$emit('value2FA', this.fieldCurValue)
				return
			}

			// если это внешний диск - поле авторолонгация
			if (this.crud === 'disks' && this.Field._field_name === 'autoprolong') {
				// если выключают переключатель - нужно показать предупреждение
				if (this.fieldCurValue) {
					this.$emit('autoprolongWarning')
					return
				}
			}

			// можно работать
			this.fieldCurValue = !this.fieldCurValue
			this.$emit('input', this.fieldCurValue)
			this.$emit('valueChanged', this.Field)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// DATE
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// выбор значения
		onDateSelect(e) {
			if (e === undefined || e === null || String(e).trim() === '')
			{
				// как есть
				this.fieldCurValue = null
			}
			else
			{
				// объект Date
				this.fieldCurValue = e
				this.isDateSelected = true
			}
			// сообщаем родителям
			this.$emit('input', this.formater_Date2StrDate(this.fieldCurValue, true))
			this.$emit('valueChanged', this.Field)
			this.$emit('blur')
		},
		// открыли выбор даты
		onDateOpen() {
			// hack
			$(this.$refs[this.Field._field_name].$el).find('input:first').focus()
			// при первом фокусе - включаем анимацию (по умолчанию она отключена)
			this.fieldAnimated = true
			// метим элемент как элемент с фокусом
			this.fieldFocused = true
			// если не задано значение - ставим текущий день
			if (!this.value) this.fieldCurValue = this.formater_Date2StrDate(new Date(), true)
			// сообщаем родителям
			this.$emit('focus')
		},
		// закрыли выбор даты
		onDateClose(e) {
			// hack
			$(this.$refs[this.Field._field_name].$el).find('input:first').blur()
			// метим элемент как элемент без фокуса, анимация остается включенной
			this.fieldFocused = false
			// было выбрано какое то значение даты
			if (this.isDateSelected)
			{
				this.isDateSelected = false
				return
			}
			// если изначальное значение не задано, и ничего не выбрано
			if (!this.value) this.fieldCurValue = null
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// LIST
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// выбор значения
		onSelect(e) {
			if (!e) return

			// если это мультиселект
			if (this.Field.multiselect === true)
			{
				// объект должен быть массивом значений
				if (!Array.isArray(e)) return
				// обнуляем значение
				this.fieldCurValue = []
				// если искали списком
				if (this.Field.queryList !== undefined && this.Field.queryList !== null && this.Field.queryList !== false)
				{
					// проверим количество искомых и найденых значений
					if (this.Field.queryList !== this.curList.length)
						this.Field.warningList = this.localeFtc('main/found_less')
							.replace('{find}', this.Field.queryList)
							.replace('{found}', this.curList.length)
					else
						this.Field.warningList = null
					// теперь можно обнулить флаг
					this.Field.queryList = false

					// формируем значение списка
					this.listValue = []
					this.curList.forEach(item => {
						if (item['id'])
						{
							this.fieldCurValue.push(item['id'])
							this.listValue.push(item)
						}
					})
				}
				else
				{
					// в текущее значение запоминаем только ID
					e.forEach(item => {
						if (item['id']) this.fieldCurValue.push(item['id'])
					})
				}
			}
			// это одиночный селект
			else
			{
				// если задано специальное пустое значение
				if (e.id === 'emptyValue' || e.id === 'noValue') this.fieldCurValue = ''
				else if (e.id === 'zeroValue') this.fieldCurValue = 0
				else this.fieldCurValue = e.id

				// частный случай
				if ((this.crud === 'vds' && this.Field['_field_name'] === 'sshkey_id') ||
					(this.crud === 'domains' && this.Field['_field_name'] === 'person_id'))
				{
					if (e.id === 'emptyValue') this.listValue = {}
				}

				if (this.Field && this.Field._field_name && this.crud === 'rackdevice' && this.action === 'links')
				{
					// если поменялось значение в оборудовании
					if (this.Field._field_name.indexOf('device_id') === 0)
					{
						// выбрали пустое значение
						if (e.id === 'emptyValue')
						{
							// обнуление значения
							this.listValue = null
							this.fieldCurValue = null
							// так же обнулим порт с таким же индексом
							let m = this.Field._field_name.match(/^device_id\[(\d+)\]$/)
							if (m && m.length && m[1])
							{
								EventBus.$emit('w5-clear-list-field', 'port_id[' + m[1] + ']')
								this.$emit('freePort', 'from[' + m[1] + ']')
							}
						}
					}
					// если выбрали порт
					else if (this.Field._field_name.indexOf('port_id') === 0)
					{
						// не даем выбрать неактивные итемы
						if (!e.active)
						{
							if (this.Field.perviousValues)
							{
								this.fieldCurValue = this.Field.perviousValues.id
								this.listValue = this.Field.perviousValues.obj
							}

							return false
						}
					}
				}

				if (this.Field && this.Field._field_name === 'vdsId' && this.crud === 'disks' && this.fieldInModal)
				{
					// не даем выбрать неактивные итемы
					if (!e.active)
					{
						// обнуление значения
						this.listValue = null
						this.fieldCurValue = null

						if (this.Field.perviousValues)
						{
							this.fieldCurValue = this.Field.perviousValues.id
							this.listValue = this.Field.perviousValues.obj
						}

						return false
					}
				}
			}

			// сообщаем родителям
			this.$emit('input', this.fieldCurValue)
			this.$emit('valueChanged', Object.assign(this.Field, { 'listValue': this.listValue }))

			// если это лейблы
			if (this.Field._field_name === 'set_label')
				this.$nextTick(() => { this.ticketLabelSelected($(this.$el)) })

			// страна в персона
			if (this.crud === 'person' && this.Field._field_name.indexOf('country'))
				EventBus.$emit('w5-get-field-value-answer', {
					name: this.Field._field_name,
					value: this.fieldCurValue
				})
		},
		// открыли
		onListOpen() {
			this.countUlBlockForListInModal()
			// ставим флаг что открыт список
			this.Field.__listOpened = true
			// запоминаем предыдущее значение
			this.Field.perviousValues = {
				id: this.fieldCurValue,
				obj: this.listValue
			}
			// при первом фокусе - включаем анимацию (по умолчанию она отключена)
			this.fieldAnimated = true
			// метим элемент как элемент с фокусом
			this.fieldFocused = true
			// рамка при фокусе на контрол
			if (!this.$listTag) this.$listTag = $(this.$el).find('div.multiselect__tags:first')
			if (this.$listTag.length) this.$listTag.addClass('multiselect__tags__focused')
			// обнуляем предупрежедение если есть
			if ('warningList' in this.Field) this.Field.warningList = null
			// сообщаем родителям
			this.$emit('focus')
		},
		// специальные формы полей "List"
		specialForm() {
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это лейблы
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.Field._field_name === 'set_label')
			{
				let $block = $(this.$el)
				if ($block.length)
				{
					// проеобразуем к кругляшкам - ищем все элементы списка
					$block.find('li.multiselect__element').each(function() {
						// в каждом элементе ищем блок с текстом
						let _span = $(this).find('span.multiselect__option:first')
						// если нашли такой блок
						if (_span.length)
						{
							// если еще не преобразован
							if (!_span.children('div:first').length)
							{
								// получим его текст - это должен быть цвет
								let _color = _span.text().toLowerCase().trim()
								// сформируем блок
								_span.html(
									$('<div class="w5-ticket-label" />')
										.addClass('w5-ticket-label-color-' + _color)
								)
							}
						}
					})
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если это поле с IP-адресом
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.crud === 'logs' && this.Field._field_name === 'ipBlackList')
			{
				let $block = $(this.$el)
				if ($block.length)
				{
					let $input = $block.find('input:first')
					if ($input.length)
					{
						Inputmask({
							mask: '9{1,3}.9{1,3}.9{1,3}.9{1,3}',
							placeholder: '_',
							showMaskOnHover: false,
							undoOnEscape: false
						}).mask($input)
					}
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			// если указали подсказку ссылку для списка - создаем ее вручную
			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
			if (this.linkHint && this.linkHint.showIfField === this.Field._field_name && this.Field.type === 'list')
			{
				let $block = $(this.$el)
				if ($block.length)
				{
					$('<div class="w5-info-link margin-top-5">' +
						'<svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="link" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-link fa-w-16"><path data-v-4dd73f47="" fill="currentColor" d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z" class=""></path></svg>' +
						'<span>' +
						this.linkHintHtml(this.linkHint) +
						'<span class="font-weight-500"> ' +
						this.localeFtc(this.linkHint.afterText) + '</span></span></div>')
						.appendTo($block)
				}
			}

			//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		},
		// расчет координат и размеров блока списка в модальном диалоге
		countUlBlockForListInModal() {
			// если это список в модальном окне
			if (this.listBlockToOut && this.listBlockToOut !== true)
			{
				// пересчитаем координаты блока со списком
				// каждый раз - так как окно могут изменить
				let $el = $(this.$el)
				if ($el.length && this.$ulBlock && this.$ulBlock.length)
				{
					let _elHeight = $el.height()
					let _elOffset = $el.offset()
					this.$ulBlock.css({
						top: _elOffset.top + _elHeight + 10,
						left: _elOffset.left,
						zIndex: 9998,
						width: $el.width() + 'px'
					})
				}
			}
		},
		// открывать вверх или вниз
		listOpenDirection() {
			// получим JQ-блок поля
			let $component = $(this.$el)
			if ($component && $component.length)
			{
				// пропишем жестко стиль блоку
				let _css = {
					'width': this.removeRightPadding ? '100%' : 'calc(100% - 10px)',
					'z-index': 99
				}
				// хватает ли места внизу
				let hasEnoughSpace = this.$el.getBoundingClientRect().top + 300 < window.innerHeight
				if (!hasEnoughSpace)
				{
					// вносим изменения
					$component.addClass('multiselect--above')
					_css['margin-bottom'] = '-10px'
				}

				// частный случай
				if (this.crud === 'vds') $component.removeClass('multiselect--above')

				if (this.$ulBlock && this.$ulBlock.length) this.$ulBlock.css(_css)
			}

			this.countUlBlockForListInModal()
		},
		// закрыли
		onListClose(e) {
			// ставим флаг что список закрыт
			this.Field.__listOpened = false
			// метим элемент как элемент без фокуса, анимация остается включенной
			this.fieldFocused = false
			// рамка при фокусе на контрол
			if (!this.$listTag) this.$listTag = $(this.$el).find('div.multiselect__tags:first')
			if (this.$listTag.length) this.$listTag.removeClass('multiselect__tags__focused')
		},
		// выбор бэкапа в создании VDS
		onBackupValueChanged(value) {
			// сообщим полю с бэкапом
			EventBus.$emit('w5-set-list-field-value', { name: 'backup_id', value })
		},
		// выбра фильтра в шаблонах
		onTemplateTab(tab) {
			this.$emit('templateTab', tab)
		},
		// получили список бэкапов
		onBackupList(list) {
			this.$emit('backupList', list)
		},
		// изменилось значение поля OS создании VDS
		onTemplateInput(data) {
			if (!data || !data.tab) return

			if (data.tab === 'template' || data.tab === 'template-panel')
			{
				if (data.value)
				{
					EventBus.$emit('w5-set-list-field-value', {
						name: 'template_id',
						value: { id: data.value }
					})
				}
				else
				{
					EventBus.$emit('w5-set-list-field-value', { name: 'template_id', value: null })
				}

				EventBus.$emit('w5-set-list-field-value', { name: 'backup_id', value: null })
				EventBus.$emit('w5-set-list-field-value', { name: 'iso_id', value: null })
			}
			else if (data.tab === 'backup')
			{
				EventBus.$emit('w5-set-list-field-value', { name: 'template_id', value: null })
				EventBus.$emit('w5-set-list-field-value', {
					name: 'backup_id',
					value: { id: data.value }
				})
				EventBus.$emit('w5-set-list-field-value', { name: 'iso_id', value: null })
			}
			else if (data.tab === 'iso')
			{
				EventBus.$emit('w5-set-list-field-value', { name: 'template_id', value: null })
				EventBus.$emit('w5-set-list-field-value', { name: 'backup_id', value: null })
				EventBus.$emit('w5-set-list-field-value', {
					name: 'iso_id',
					value: { id: data.value }
				})
			}

			// для просмотра проталкиваем вверх к родителю
			if (this.action === 'view')
				this.$emit('templateInput', data)
		},
		// требуется создание бэкапа
		createBackup() {
			this.$emit('createBackup')
		},
		// выбор лейблов тиектов
		ticketLabelSelected($block) {
			if (!$block || !$block.length) return

			// ищем значение
			let _valBlock = $block.find('span.multiselect__single:first')
			// если нашли
			if (_valBlock.length)
			{
				// получим его текст - это должен быть цвет
				let _color = _valBlock.text().toLowerCase().trim()
				// сформируем блок
				if (_color !== '')
				{
					_valBlock.html(
						$('<div class="w5-ticket-label" />')
							.addClass('w5-ticket-label-color-' + _color)
					)
				}
			}
		},
		// выбор страны
		countrySelected($block, id) {
			if (!$block || !$block.length) return
			if (!id || id === '' || id === 'noValue') return

			// ищем значение
			let _valBlock = $block.find('span.multiselect__single:first')
			// если нашли
			if (_valBlock.length)
			{
				// установим флаг
				$('<span class="flag-icon flag-icon-' + id.toLowerCase() + '" style="margin-right: 10px;"></span>').prependTo(_valBlock)
			}
			else
			{
				// ищем значение
				_valBlock = $block.find('div.multiselect__tags:first')
				// если нашли
				if (_valBlock.length)
				{
					// удалим старый флаг
					_valBlock.find('span.flag-icon').remove()
					// установим флаг
					_valBlock.find('input:first').css({'width': '70%', 'padding-left': '6px'})
					$('<span class="flag-icon flag-icon-' + id.toLowerCase() + '" style="margin-left: 12px"></span>').prependTo(_valBlock)
				}
			}
		},
		// поиск по URL
		asyncListFind(query) {
			// если нет URL'a
			if (!this.Field.url) return

			// если запрос пустой - просто обнулим список
			if (!query)
			{
				this.$set(this, 'curList', [])
				return
			}

			// если уже заряжен таймер - обнулим
			if (this.serachInputTimer) clearTimeout(this.serachInputTimer)

			// заряжаем новый таймер
			this.serachInputTimer = setTimeout(() => {
				// сформируем URL
				let _url = Vue.APIServerUrl + this.Field.url
				// добавим значение поиска
				if (this.Field.multiselect === true && query.indexOf(',') > 0)
				{
					_url += query.replace(/ /g, '')
					let _values = query.split(',').filter(item => item && item.length)
					this.Field.queryList = _values.length
				}
				else
				{
					this.Field.queryList = false
					_url += query
				}

				// не нужно показывать лоадер
				this.$store.commit('needShowLoader', false)

				// делаем запрос
				this.statusListRequestResult = ''
				this.statusListRequestProcess = 'Поиск...'
				this.$http.get(_url, {
					// определим колбак "before"
					before(request) {
						// если есть предыдущий запрос - прервем его
						if (this.previousRequest) this.previousRequest.abort()
						// установим в предыдущий запрос - текущий
						this.previousRequest = request
					}
				}).then(
					response => {
						// процесс закончен
						this.statusListRequestProcess = ''
						this.$store.commit('needShowLoader', true)
						// обнуляем текущий список
						this.curList = []
						// если пришел корректный ответ - копируем список
						if (response &&
							typeof response === 'object' &&
							response.data && typeof response.data === 'object' &&
							response.data['status'] === 'ok' &&
							response.data['result'] &&
							Array.isArray(response.data['result']))
						{
							response.data['result'].forEach(item => {
								// форматируем полученный объект базовыми полями
								const _item = {
									'id': String(item.id),
									'name': item.name,
									'active': this.activeItem(item)
								}

								// если есть дополнительные поля
								if ('type' in item) {
									_item['type'] = item.type
								}

								// если есть флаг active
								if ('active' in item) {
									_item['$isDisabled'] = !this.activeItem(item)
								}

								// заносим в массив
								this.curList.push(_item)
							})
						}

						if (this.curList.length <= 0) this.statusListRequestResult = 'main/search_not_found'
					},
					() => this.$store.commit('needShowLoader', true)
				)
			}, 500)
		},
		// активный эелмент списка или нет
		activeItem(item) {
			// частный случай
			// создание тикета сотрудником
			if (this.$store.state.user_type === 'admin' &&
				this.crud === 'ticket' && this.action === 'create' &&
				this.Field.type === 'list' &&
				this.Field._field_name.indexOf('multi_value') > -1)
			{
				// всегда активны
				return true
			}
			// по умолчанию, если не указано ничего - активен
			if (!('active' in item)) return true
			// если что то указанао - смотрим на то что указано
			return item['active'] === true
		},
		// производим фильтрацию списка на предмет активного или неактивного
		filterActiveList(list) {
			// проверка параметра
			if (!list) return list
			// для сотрудников ничего не фильтруем
			if (this.$store.state.user_type === 'admin')
			{
				// если объект - конвертанем в массив
				if (this.Field.type === 'radio')
					list = Helper.listAsArray(list)
				return list
			}
			// если объект - конвертанем в массив
			list = Helper.listAsArray(list)
			// для клиентов производим фильтрацию по следующим правилам:
			// 1) при создании/заказе услуг - неактивные варианты не должны быть доступны
			// 2) при редактировании:
			// 2.1) должны отображаться только если они изначально выбраны
			// 2.2) если выбрано что-то другое - не должны отображаться
			return list.filter(item => {
				if (this.action === 'create' || this.action === 'view')
				{
					// в просмотре вдс нужно текущий всегда показывать
					if (this.crud === 'vds' && this.action === 'view' && String(item['id']) === String(this.fieldCurValue)) return true
					// 1)
					if (item['active'] === false) return false
				}
				else if (this.action === 'update')
				{
					// 2.2)
					if (this.Field.value !== item['id']) return false
				}
				// по умолчанию передаем все итемы
				return true
			})
		},
		// изменение строки поиска
		mySearchFunction(txt) {
			this.searchText = txt
		},
		// подготовка списка
		preparedStaticList(list) {
			// если нет строки поиска
			if (!this.searchText) return list

			// что ищут
			let txt = this.searchText.toLowerCase()

			// если ничего - возвращаем как есть
			if (!txt) return list

			// если это домен
			if (this.crud === 'dns')
			{
				// если мы тут - поиск хоть где
				return list.filter(item => {
					return String(item['name']).toLowerCase().indexOf(txt) > -1
				})
			}

			// если мы тут - поиск идет сначала с начала
			let _foundList = list.filter(item => {
				return String(item['name']).toLowerCase().indexOf(txt) === 0
			})

			// если что то нашли
			if (_foundList && _foundList.length) return _foundList

			// ищем хоть где
			return list.filter(item => {
				return String(item['name']).toLowerCase().indexOf(txt) > -1
			})
		},
		// подготовка списка стран дата центра
		filterListForDataCenterInVds(list) {
			return list
		},
		// изменения в списке доступа пользователя
		onSelectUserRole(values) {
			this.Field['value'] = values
		},
		setColorOfItems() {
			// ждем следующего тика - что бы все уже было сформировано
			this.$nextTick(() => {
				// делаем все в бэкграунде
				setTimeout(() => {
					/*
					// найдем врапер текущего поля
					let $component = $(this.$el)
					if (!$component.length) return

					// найдем блок со списком
					let $ul = $component.find('ul:first')
					if (!$ul.length) return
					*/

					// текущий список итемов
					let options = this.Field.list
					if (!options) return
					if (Array.isArray(options) && !options.length) return
					if (typeof options === 'object' && !Object.keys(options).length) return

					// пробуем получить VueComponent
					// начинаем с текущего
					let $comp = $(this)
					if ($comp && $comp.length) $comp = $comp[0]

					// получим доступ к компоненту vue-multiselect
					if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0]
					if (!$comp) return

					// подменим функцию
					$comp.isSelected = function(option) {
						const opt = this.trackBy
							? option[this.trackBy]
							: option

						let Keys = this.valueKeys && this.valueKeys.length
							? this.valueKeys.map(String)
							: []

						return Keys.indexOf(String(opt)) > -1
					}

					$comp.optionHighlight = function(index, option) {
						return {
							'multiselect__option--highlight': index === this.pointer && this.showPointer,
							'multiselect__option--selected': this.isSelected(option),
							'multiselect__option--notactive': option.active === false || option.archive === true
						}
					}

					// скроллинг до значения
					if (!this.Field.multiselect && $comp.getValue)
					{
						let _val = $comp.getValue()
						if (_val && _val.id && $comp.options && $comp.options.length)
						{
							for (let _idx in $comp.options)
							{
								let _option = $comp.options[_idx]
								if (_option && _option.id === _val.id)
								{
									$comp.pointer = _idx
									$comp.pointerDirty = true
									let _position = _idx * $comp.optionHeight
									if ($comp.$refs.list.scrollTop <= _position)
										$comp.$refs.list.scrollTop = _position
									break
								}
							}
						}
					}
				}, 10)
			})
		},
		scopedRemoveElement(element) {
			// пробуем получить VueComponent
			// начинаем с текущего
			let $comp = $(this)
			if ($comp && $comp.length) $comp = $comp[0]
			// получим доступ к компоненту vue-multiselect
			if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0]
			// вызываем функцию
			if ($comp && $comp.removeElement) $comp.removeElement(element)
		},
		scopedGetOptionLabel(element) {
			// пробуем получить VueComponent
			// начинаем с текущего
			let $comp = $(this)
			if ($comp && $comp.length) $comp = $comp[0]
			// получим доступ к компоненту vue-multiselect
			if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0]
			// вызываем функцию
			if ($comp && $comp.getOptionLabel) return $comp.getOptionLabel(element)
			else return ''
		},
		getPlanInfo(plan) {
			if (!plan) return ''

			let answer = ''
			if (plan.ram_text && plan.ram_name) answer = plan.ram_text + ' ' + plan.ram_name
			if (plan.cpu_text && plan.cpu_name)
			{
				if (answer) answer += ' / ' + plan.cpu_text + ' ' + plan.cpu_name
				else answer = plan.cpu_text + ' ' + plan.cpu_name
			}
			if (plan.disk_text && plan.disk_name)
			{
				if (answer) answer += ' / ' + plan.disk_text + ' ' + plan.disk_name
				else answer = plan.disk_text + ' ' + plan.disk_name
			}

			return answer
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик клавиш
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		keyDownHandler(e) {
			// селект в диалоге
			if (this.Field.type === 'list' && this.fieldInModal) {
				if (e && e.keyCode === 27) {
					if (this.Field.__listOpened) {
						e.preventDefault()
						e.stopPropagation()
						e.stopImmediatePropagation()
					}

					let $comp = $(this)
					if ($comp && $comp.length) $comp = $comp[0]

					// получим доступ к компоненту vue-multiselect
					if ($comp && $comp.$children && $comp.$children.length) $comp = $comp.$children[0]
					if (!$comp || !$comp.deactivate) return

					$comp.deactivate()

					return false
				}
			}
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// FILE
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// нужно заблокировать кнопку формы
		blockFormButton() {
			this.$emit('blockFormButton')
		},
		// нужно разблокировать кнопку формы
		unblockFormButton() {
			this.$emit('unblockFormButton')
		},
		// выбрали координаты (crop)
		cropCoords(data) {
			this.$emit('cropCoords', data)
		},
		// пришли координаты (crop)
		getCropData(data) {
			// если это одно из полей, которое хранит координаты
			if (this.Field['_field_name'] !== 'a_x' &&
				this.Field['_field_name'] !== 'a_y' &&
				this.Field['_field_name'] !== 'a_w' &&
				this.Field['_field_name'] !== 'a_h')
				return
			// проверка пришедших данных
			if (!data) return

			// установим значения в поля
			if (this.Field['_field_name'] === 'a_x') this.fieldCurValue = Math.round(data['x'])
			else if (this.Field['_field_name'] === 'a_y') this.fieldCurValue = Math.round(data['y'])
			else if (this.Field['_field_name'] === 'a_w' || this.Field['_field_name'] === 'a_h') this.fieldCurValue = Math.round(data['w'])

			// в любом случае сообщаем родителю
			this.$emit('input', this.fieldCurValue)
		},
		// пришло значение для текстового поля
		setTextValueByEvent(data) {
			// только для текстовых полей
			if (this.Field['type'] !== 'text' && this.Field['type'] !== 'address') return
			// проверка данных
			if (!data || typeof data !== 'object' || !data['name'] || !('value' in data)) return
			// если это не нам
			if (data['name'] !== this.Field['_field_name']) return
			// меняем текущее значение
			this.fieldCurValue = data['value']
			// в любом случае сообщаем родителю
			this.$emit('input', this.fieldCurValue)
		},
		// обнуление значения списка
		clearListField(fieldName) {
			// только для полей с типом list (и частные случаи таких полей - savedPayments)
			if (this.Field['type'] !== 'list' && this.Field['type'] !== 'savedPayments') return
			// если это не нам
			if (fieldName !== this.Field['_field_name']) return
			// чистим список и значение
			this.curList = []
			this.listValue = null
			this.fieldCurValue = null
			this.Field.value = null

			// передадим в эфир
			if (this.crud === 'vds')
			{
				this.Field.list = []
				EventBus.$emit('w5-vds-create-field-reloaded', this.Field._field_name)
			}
		},
		// установки ошибки поля
		setFieldError() {
			// только для полей с типом boolean
			if (this.Field['type'] !== 'boolean') return
			this.timerBooleanFieldError = setTimeout(() => {
				this.Field['_errMsg'] = ''
			}, 30000)
		},
		// пришло значение для поля Date
		setDateValueByEvent(data) {
			// только для полей с типом date
			if (this.Field['type'] !== 'date') return
			// проверка данных
			if (!data || typeof data !== 'object' || !data['name'] || !('value' in data)) return
			// если это не нам
			if (data['name'] !== this.Field['_field_name']) return
			// меняем текущее значение
			if (this.Field.format)
				// если задан еще и формат
				this.fieldCurValue = this.formater_FormatedStrDate2Date(data['value'], this.Field.format)
			else
				// без формата
				this.fieldCurValue = this.formater_StrDate2Date(data['value'])
			// в любом случае сообщаем родителю
			this.$emit('input', this.formater_Date2StrDate(this.fieldCurValue, true))
		},
		// пришло значение для поля bool
		setBoolValueByEvent(data) {
			// только для полей с типом boolean
			if (this.Field['type'] !== 'boolean') return
			// проверка данных
			if (!data || typeof data !== 'object' || !data['name'] || !('value' in data)) return
			// если это не нам
			if (data['name'] !== this.Field['_field_name']) return
			// меняем текущее значение
			this.fieldCurValue = data['value']
			// в любом случае сообщаем родителю
			this.$emit('input', this.fieldCurValue)
		},
		// пришло значение для поля List
		setListValueByEvent(data) {
			// только для полей с типом list
			if (this.Field['type'] !== 'list') return
			// проверка данных
			if (!data || typeof data !== 'object' || !data['name'] || !('value' in data)) return
			// если это не нам
			if (data['name'] !== this.Field['_field_name']) return

			// меняем текущее значение
			this.fieldCurValue = data.value && data.value.id ? data.value.id : null
			this.listValue = data.value && data.value.id ? data.value : null

			// сообщаем родителям
			this.$emit('input', this.fieldCurValue)

			// дополнительно сообщим
			if (this.crud === 'vds' && this.action === 'create')
			{
				if (this.Field._field_name === 'template_id' ||
					this.Field._field_name === 'backup_id' ||
					this.Field._field_name === 'iso_id')
				{
					this.$emit('valueChanged', this.Field)
				}
			}
		},
		// нажали клавишу Enter на поле
		enterKeyDown(e) {
			this.$emit('enterKeyDown', e)
		},
		// метка - удаляют файл или нет
		deleteFileValue(data) {
			this.$emit('deleteFileValue', data)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// подтверждение mini-формы пополнения баланса клиентом
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onSubmitButton(e) {
			this.$emit('onSubmit', e)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клиент выбрал способ оплаты
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onClientOperationNextStep(id) {
			this.$emit('operationNextStep', id)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// клиент удаляет сохраненный способ оплаты
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onDeleteSavedPayment(id) {
			this.$emit('deleteSavedPayment', id)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// требуется диалог выбора шаблона ответа
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		templateDialog() {
			this.$emit('answerTemplateDialog')
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// выбор даты и времени в компоненте datetime
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		datetimeInput(e) {
			this.$emit('input', e)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// определяет пустое значение для текущего поля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		emptyFieldValue() {
			// определим пустое значение поля
			let _emptyValue

			// сначала идут частные случаи
			if (this.Field._field_name === 'plan_id' && this.crud === 'vds')
			{
				let selected = null
				if (this.Field.list && this.Field.list.length)
				{
					this.Field.list.some(item => {
						if (item.selected === true && item.id)
						{
							selected = String(item.id)
							return true
						}
					})
				}

				if (selected) _emptyValue = selected
				else _emptyValue = '16'
			}
			else if (this.Field._field_name === 'template_id' && this.crud === 'vds')
			{
				_emptyValue = undefined
			}
			else if (this.Field.type === 'slider' && ('min' in this.Field))
			{
				_emptyValue = this.Field.min
				if ('value' in this.Field && this.action !== 'create') _emptyValue = this.Field.value
			}
			else if (this.Field._field_name === 'payment' && this.crud === 'operation' && this.$store.state.user_type !== 'admin')
			{
				_emptyValue = null
			}
			else if (
				(this.Field._field_name === 'plan_id' && this.crud === 'certificate') ||
				(this.Field._field_name === 'plan_group_id' && this.crud === 'vds')
			)
			{
				// тут пустое значение - это первое значение в списке
				_emptyValue = ''
				if (this.Field.list && this.Field.list.length && this.Field.list[0] && this.Field.list[0]['id'])
					_emptyValue = this.Field.list[0]['id']
			}
			else if (this.Field._field_name === 'host' && this.crud === 'dns-records')
			{
				_emptyValue = ''
			}
			// теперь общие случаи
			else
			{
				if (this.Field['type'] === 'hidden' ||
					this.Field['type'] === 'text' ||
					this.Field['type'] === 'password' ||
					this.Field['type'] === 'email' ||
					this.Field['type'] === 'textarea')
					_emptyValue = ''
				else if (this.Field['type'] === 'money' || this.Field['type'] === 'integer' || this.Field['type'] === 'float')
					_emptyValue = null
				else if (this.Field['type'] === 'date')
					_emptyValue = null
				else if (this.Field['type'] === 'datetime')
					_emptyValue = null
				else if (this.Field['type'] === 'boolean')
				{
					if ('_oldValue' in this.Field)
						_emptyValue = this.Field._oldValue
					else
						_emptyValue = false
				}
				else if (this.Field['type'] === 'image' || this.Field['type'] === 'file')
					_emptyValue = null
				else if (this.Field['type'] === 'list')
				{
					if (this.Field['multiselect'] === true) _emptyValue = []
					else _emptyValue = ''
				}
			}

			return _emptyValue
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// требуется инициализация начального значения текущего поля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		initOldValue() {
			// ставим признак процесса инициализации значений форм
			this.$store.commit('isInitFormsValue', true)

			// даем время для всяких reloadif и showif
			setTimeout(() => {
				if (!('_emptyValue' in this.Field))
				{
					// определим пустое значение поля
					let _emptyValue = this.emptyFieldValue()
					// запомним его для сверки
					this.Field['_emptyValue'] = _emptyValue

					// установим начальное значение
					if (this.fieldCurValue !== null && this.fieldCurValue !== undefined)
					{
						if (this.Field['type'] === 'date')
						{
							this.Field['_oldValue'] = this.formater_Date2StrDate(this.fieldCurValue, true)
						}
						else if (this.Field['type'] === 'boolean' || this.Field['type'] === 'slider')
						{
							this.Field['_oldValue'] = _emptyValue
						}
						else if (this.fieldCurValue === 'noValue' || this.fieldCurValue === 'emptyValue')
						{
							this.Field['_oldValue'] = ''
						}
						else if (this.Field['_field_name'] === 'plan_id')
						{
							this.Field['_oldValue'] = _emptyValue
						}
						else
						{
							this.Field['_oldValue'] = this.fieldCurValue
						}
					}
					else this.Field['_oldValue'] = _emptyValue
				}

				// отключаем признак процесса инициализации
				this.$store.commit('isInitFormsValue', false)
			}, 400)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// восстановление поля из блока приложения
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		fromBlock() {
			if (this.Field['type'] === 'list' && this.Field['listValue'])
			{
				this.listValue = Object.assign({}, this.Field['listValue'])
				return
			}
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// резулььтат поиска в QA при создании тикетов
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		qaSearchResult(arr) {
			this.qaResult = false
			if ((this.crud === 'ticket' && this.action === 'create') ||
				(this.crud === 'qa' && this.action === 'list') &&
				this.$store.state.user_type === 'client')
				if (arr && Array.isArray(arr))
				{
					// slice тут не подходит - нужно форматирование ответа
					this.qaResult = arr.map((item) => {
						return {
							'ans': item.ans.replace('<span>', '').replace('</span>', ''),
							'url': item.url,
							'cap': item.cap
						}
					})
				}
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// проброс функции для большой кнопки
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		bigButtonHandlerFunc(e) {
			if (!this.bigButtonEnabled) return

			if (this.bigButtonHandler && typeof this.bigButtonHandler === 'function')
				this.bigButtonHandler(e)
			else
				this.enterKeyDown(e)
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// попросили сделать анимацию
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		animationRequested() {
			this.$nextTick(() => {
				let _el = $(this.$el)
				if (!_el || !_el.length) return

				// бэкграунд для поля ввода
				if (this.Field.type === 'money')
				{
					let _inp = _el.find('input:first')
					if (_inp.length)
					{
						_inp.css({ 'background-color': 'rgba(54, 155, 242, .6)' })
						setTimeout(() => _inp.css({ 'background-color': 'rgba(54, 155, 242, .2)' }), 100)
						setTimeout(() => _inp.css({ 'background-color': 'rgba(0,0,0,0)' }), 300)
					}

					_el
					.animate({ left: 5 }, 100)
					.animate({ left: 0 }, 50)
					.animate({ left: 4 }, 100)
					.animate({ left: 0 }, 50)
					.animate({ left: 3 }, 50)
					.animate({ left: 0 }, 50)
				}
			})
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// запросили анимацию поля
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		animationFieldRequested(data) {
			if (!data || !data.field) return
			if (this.Field._field_name !== data.field) return

			this.animationHighlightField()
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// установить текст ошибки в поле
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		setErrorToField(data) {
			if (!data || !data.field || !data.text) return
			if (this.Field._field_name !== data.field) return

			this.Field._errMsg = data.text
		},
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// попросили сделать анимацию
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		animationHighlightField() {
			// анимация кнопки создания плательщика на самой форме
			this.$nextTick(() => {
				let _el = $(this.$el)
				if (!_el || !_el.length) return

				// бэкграунд для списка
				if (this.Field.type === 'list')
				{
					let _div = _el.find('div.multiselect:first')
					if (_div && _div.length)
					{
						_div.css({ 'background-color': 'rgba(54, 155, 242, .6)' })
						setTimeout(() => _div.css({ 'background-color': 'rgba(54, 155, 242, .2)' }), 100)
						setTimeout(() => _div.css({ 'background-color': 'rgba(0,0,0,0)' }), 200)
					}
				}

				// бэкграунд для кнопки
				if (this.Field.type === 'urlButton' || this.Field.type === 'boolean')
				{
					_el.css({ 'background-color': 'rgba(54, 155, 242, .6)' })
					setTimeout(() => _el.css({ 'background-color': 'rgba(54, 155, 242, .2)' }), 100)
					setTimeout(() => _el.css({ 'background-color': 'rgba(0,0,0,0)' }), 200)
				}

				_el
					.animate({ left: 5 }, 100)
					.animate({ left: 0 }, 50)
					.animate({ left: 3 }, 50)
					.animate({ left: 0 }, 50)
			})
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// изменение типа внешнего диска
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onOuterDiskTypeChanged(value) {
			// чистим каждый раз ошибку
			this.Field._errMsg = ''
			// передаем дальше наверх
			this.$emit('outerDiskTypeChanged', value)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// установка обработчиков для поля типа слайдер
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		setSliderHandlers() {
			if (!this.$refs || !this.$refs['field-' + this.Field._field_name]) return

			const $el = $(this.$refs['field-' + this.Field._field_name])
			const _this = this

			// если оно еще не инициализоровано плагином
			if (!$el.data('autoNumeric'))
			{
				// инициализируем
				$el.autoNumeric('init', { aSep: '', mDec: 0, vMin: 0, vMax: 99999 })

				// вешаем обработчик на нажатие клавишы
				$el.off('keydown').on('keydown', (e) => {
					var text = e.target
					var t = text.value.substr(text.selectionStart, text.selectionEnd - text.selectionStart)
					if (t && t.length)
					{
						$(this).val('')
					}
				})

				// навешиваем обработчик на изменение значения
				// в данном случае модуль "autoNumeric" уже обрабатывает событие "input"
				// поэтому тут мы ловим событие "keyup"
				$el.off('keyup').on('keyup', (e) => {
					_this.onInputFieldChanged($(e.target))
				})
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// измененение текстового поля слайдера
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onInputFieldChanged($input) {
			let value = $input.autoNumeric('get')

			// обнулим ошибку
			this.outerDiskError = ''

			// получим значение в текстовом поле
			let _value = parseInt(value, 10)
			if (isNaN(_value))
			{
				this.outerDiskError = 'validators/error_int'
				this.outerDiskValue = value
				return
			}

			// обновим значение в состоянии
			this.outerDiskValue = _value

			// если пустое - ничего не делаем, пустое значение будет обработано в событии "blur"
			if (!value || !value.length) return

			// проверка границ
			if (_value < this.Field.min || _value > this.Field.max)
			{
				this.outerDiskError = 'Min: ' + this.Field.min + ', Max: ' + this.Field.max
				return
			}

			// теперь можно обновить
			this.Field._errMsg = ''
			this.fieldCurValue = this.outerDiskValue

			// сообщим родителям
			this.$emit('input', this.fieldCurValue)
			this.$emit('valueChanged', this.Field)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// блюр поля значения внешнего диска
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onSliderFieldBlurNew() {
			// если значения в поле нет или значение в поле ошибочное
			if (!this.outerDiskValue || this.outerDiskError)
			{
				this.outerDiskError = ''
				this.outerDiskValue = this.fieldCurValue
			}

			// всегда округляем значение
			if (this.Field.step > 1) {
				this.outerDiskValue = parseInt(Math.round(this.outerDiskValue / this.Field.step) * this.Field.step)
				this.fieldCurValue = this.outerDiskValue
			}

			// ставим в поле значение руками (в слайдере само поставилось v-model)
			let $input = $(this.$refs['field-' + this.Field._field_name])
			if ($input && $input.length && $input.autoNumeric)
			{
				$input.autoNumeric('set', this.fieldCurValue)
			}

			// сообщим родителям
			this.$emit('input', this.fieldCurValue)
			this.$emit('valueChanged', this.Field)
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},
	//=========================================================================
	// наблюдатели
	//=========================================================================
	watch: {
		// изменение формы (crud изменился)
		crud() {
			this.getTopHint()
		},
		// изменение формы (action изменился)
		action() {
			this.getTopHint()
		},
		// изменение модели родителем
		'value': function(value) {
			// для текстов и скрытых полей
			if (this.Field.type === 'textarea' || this.Field.type === 'text' || this.Field.type === 'hidden' || this.Field.type === 'password')
			{
				this.fieldCurValue = value
				return
			}

			// для списков
			if (this.Field.type === 'list')
			{
				if (value && typeof value === 'object' && 'id' in value && 'name' in value)
				{
					this.fieldCurValue = value.id
					this.listValue = value
					return
				}
				else if (value === null)
				{
					if (this.crud === 'ticket') this.listValue = {}
				}
				else if (value === false)
				{
					// обнулим значение по умолчанию
					this.listValue = null
					this.fieldCurValue = null
				}
			}

			// для чисел
			if (this.Field.type === 'int' || this.Field.type === 'integer' || this.Field.type === 'float' || this.Field.type === 'money')
			{
				this.fieldCurValue = value
				return
			}

			// для картинок и файлов
			if (this.Field.type === 'file' || this.Field.type === 'image')
			{
				this.fieldCurValue = value
				return
			}

			// для дат
			if (this.Field.type === 'date')
			{
				if (value !== null && value !== undefined)
				{
					// неверное значение
					if (value === 'not-date')
					{
						this.fieldCurValue = value
						return
					}

					// если есть формат
					if (this.Field.format)
						// если задан еще и формат
						this.fieldCurValue = this.formater_FormatedStrDate2Date(value, this.Field.format)
					else
						// без формата
						this.fieldCurValue = this.formater_StrDate2Date(value)
				}
				else this.fieldCurValue = null
				return
			}

			if (this.Field.type === 'datetime')
			{
				if (value === null || value === undefined) this.fieldCurValue = null
				return
			}

			// для остальных
			this.fieldCurValue = value
		},
		// изменения списка для поля List
		'Field.list': function(list) {
			// если задан список
			if (list)
			{
				//-------------------------------------------------------------
				// чистим текущий список
				//-------------------------------------------------------------
				this.curList = []

				// если список пришел сразу в виде массива
				if (Array.isArray(list))
				{
					// приведем к нужному виду
					list.forEach((item) => {
						if (item) {
							// определим новый итем
							let _item = {
								'id': String(item.id),
								'name': this.localeFtc(item.name),
								'archive': item.archive,
								'status': item.status,
								'max': item.max,
								'min': item.min,
								'type': item['type'],
								'plan': item.plan,
								'template': item.template,
								'datacenter': item.datacenter,
								'active': this.activeItem(item)
							}

							// если есть флаг active
							if ('active' in item) {
								_item['$isDisabled'] = !this.activeItem(item)
							}

							// заносим в массив
							this.curList.push(_item)
						}
					})
				}
				else
				{
					// задан в виде объекта - конвертируем в массив
					for (let _id in list)
					{
						// заносим в массив
						if (_id === '')
						{
							// частные случаи пустых значений
							if (this.crud === 'datacenter')
							{
								this.curList.push({
									'id': 'noValue',
									'name': this.localeFtc(this.Field.list[_id])
								})
							}
							// общий случай для пустых значений
							else this.curList.push({
								'id': 'emptyValue',
								'name': ' '
							})
						}
						else
						{
							this.curList.push({
								'id': String(_id),
								'name': this.localeFtc(list[_id])
							})
						}
					}
				}

				//-------------------------------------------------------------
				// теперь не для всех полей установим значение - первым значением из списка
				//-------------------------------------------------------------
				// но сначала частные случаи
				if (this.Field['_field_name'] === 'plans' || this.Field['_field_name'] === 'templates')
				{
					// запомним выбранные значения
					let _values = []
					if (this.fieldCurValue && Array.isArray(this.fieldCurValue))
						this.fieldCurValue.forEach(i => { _values.push(i) })

					// обнулим значение по умолчанию
					this.listValue = null
					this.fieldCurValue = null

					// удалим только те значения, которых нет в новом списке
					_values.forEach(v => {
						// ищем в текущем списке
						this.curList.some(item => {
							if (String(item['id']) === String(v))
							{
								if (!this.listValue) this.listValue = []
								if (!this.fieldCurValue) this.fieldCurValue = []

								this.listValue.push(item)
								this.fieldCurValue.push(v)
								return true
							}
						})
					})

					// сообщаем родителям
					this.$emit('input', this.fieldCurValue)
				}
				// загрузился список тарифов в VDS
				// или загрузился список ключей в VDS
				else if (this.crud === 'vds' &&
					(this.Field['_field_name'] === 'plan_id' || this.Field['_field_name'] === 'sshkey_id'))
				{
					// запомним старое значение
					let _oldValue = this.Field.value
					// флаг проверки - может такого значения уже нет в списке
					let _found = false

					// по умолчанию считаем что в поле не задано значение
					for (let i in list)
					{
						if (list[i] && list[i]['id'])
						{
							this.fieldCurValue = list[i]['id']
							// сообщаем родителям
							if (this.Field['_field_name'] !== 'sshkey_id')
								this.$emit('input', this.fieldCurValue)

							break
						}
						else if (list[i][0] && list[i][0]['id'])
						{
							this.fieldCurValue = list[i][0]['id']
							break
						}
					}

					// если было установлено какое то значение
					if (_oldValue)
					{
						// ставим значение без названия
						this.fieldCurValue = _oldValue
						this.listValue = { 'id': _oldValue }
						// ищем название
						for (let i in list)
						{
							if (list[i]['id'] && String(list[i]['id']) === String(this.fieldCurValue))
							{
								this.listValue['name'] = this.localeFtc(list[i]['name'])
								_found = true
								break
							}
							else if (list[i][0] && list[i][0]['id'] && String(list[i][0]['id']) === String(this.fieldCurValue))
							{
								this.listValue['name'] = this.localeFtc(list[i][0]['name'])
								_found = true
								break
							}
						}

						// сообщаем родителям
						if (_found) this.$emit('input', this.fieldCurValue)
					}
					// если старое значение не найдено, и задано какое то уже новое значение
					if (!_found && this.Field['value'])
					{
						// ставим значение без названия
						this.fieldCurValue = this.Field['value']
						this.listValue = { 'id': this.Field['value'] }
						// ищем название
						for (let i in list)
						{
							if (list[i]['id'] && String(list[i]['id']) === String(this.fieldCurValue))
							{
								this.listValue['name'] = this.localeFtc(list[i]['name'])
								_found = true
								break
							}
						}

						// сообщаем родителям
						if (_found) this.$emit('input', this.fieldCurValue)
					}
					// если так и не нашли
					if (!_found)
					{
						if (this.Field['_field_name'] === 'sshkey_id')
						{
							this.fieldCurValue = 'emptyValue'
							this.listValue = { 'id': 'emptyValue' }
						}
					}
				}
				// общий случай
				else
				{
					// если начальное значение задано
					if (this.Field.value !== undefined && this.Field.value !== null)
					{
						// частные случаи - группа в сервер
						if (this.crud === 'server' && this.Field['_field_name'] === 'groups' && this.Field.value.length)
						{
							// обнулим
							this.listValue = []
							this.fieldCurValue = []
							// нужно проставить корректные значения
							this.Field.value.forEach(item => {
								if (item && typeof item === 'object' && 'id' in item && 'name' in item)
								{
									// тут ничего делать не нужно
								}
								else
								{
									// ищем в новом списке
									this.curList.some(grp => {
										if (grp && String(grp['id']) === String(item))
										{
											this.listValue.push(grp)
											this.fieldCurValue.push(String(item))
										}
									})
								}
							})
							// сообщаем родителям
							this.$emit('input', this.fieldCurValue)
						}
						// персона в домен
						else if (this.crud === 'domains' && this.Field['_field_name'] === 'person_id' && this.Field.value.length)
						{
							// обнулим список персон
							this.listValue = null
							this.fieldCurValue = null

							// так как у нас есть уже установленное значение - ищем его в списке
							this.curList.some(prsn => {
								if (prsn && String(prsn.id) === this.Field.value)
								{
									this.listValue = prsn
									this.fieldCurValue = String(prsn.id)
									return true
								}
							})

							// сообщаем родителям
							this.$emit('input', this.fieldCurValue)
						}
						// для остальных не надо ничего делать - значение уже стоит
					}
					// если начальное значение не задано, а задан только список
					else if (this.curList && this.curList.length)
					{
						// если это мультиселект
						if (this.Field.multiselect)
						{
							// не надо ничего делать - значение и должно быть пустым
							this.listValue = []
							this.fieldCurValue = []
						}
						// если это одиночный селект
						else
						{
							// здесь идут частные случаи - когда не нужно ставить первое значение (список должен быть пустым)
							if ((this.crud === 'domains' && this.Field['_field_name'] === 'person_id') ||
								(this.crud === 'vds' && this.Field['_field_name'] === 'template_id') ||
								(this.crud === 'vds' && this.Field['_field_name'] === 'backup_id') ||
								(this.crud === 'disks' && this.Field['_field_name'] === 'backup_id') ||
								(this.crud === 'vds' && this.Field['_field_name'] === 'iso_id') ||
								(this.crud === 'operation' && this.Field['_field_name'] === 'saved' && this.$store.state.user_type === 'client') ||
								(this.crud === 'paymentauto' && this.Field['_field_name'] === 'saved_id'))
							{
								// ничего не делаем
							}
							//else if (this.crud === 'operation' && this.Field['_field_name'] === 'payment' && this.$store.state.user_type === 'client')
							//{
								// ничего не делаем
							//}
							else if (this.crud === 'rackdevice' && this.action === 'links' && this.Field['_field_name'] && this.Field['_field_name'].indexOf('port_id') === 0)
							{
								// ничего не делаем
							}
							// остальные (общие) случаи
							else
							{
								// просто берем первое значение
								this.listValue = this.curList[0]
								this.fieldCurValue = this.listValue['id']

								// в некоторых случаях может прийти значение с полем "select=true"
								if (this.crud === 'vds' && this.action === 'create' && this.Field['_field_name'] === 'datacenter_id') {
									// если такое значение найдено - то ставим его значением поля
									let _recordWithSelect = null
									list.some(el => {
										if (el && el.select === true) {
											_recordWithSelect = el
											return true
										}
									})

									// если нашли такое значение - установим его из внутреннего списка
									if (_recordWithSelect) {
										this.curList.some(el => {
											if (el && String(el.id) === String(_recordWithSelect.id)) {
												this.listValue = el
												this.fieldCurValue = this.listValue['id']
											}
										})
									}
								}

								// сообщаем родителям
								this.$emit('input', this.fieldCurValue)
								// для документов вызовем событие
								if (this.crud === 'document' && this.Field['_field_name'] === 'payer_id')
									this.$emit('valueChanged', this.Field)
							}
						}
					}

					// частный случай
					if (this.crud === 'domains' && this.action === 'create' && this.Field['_field_name'] === 'person_id')
					{
						// преобразование списка только если он пуст
						if (!this.curList.length)
						{
							// обнуление значения
							this.listValue = null
							this.fieldCurValue = null

							// добавим указание как член списка
							this.curList.push({
								'id': 'emptyValue',
								'name': this.localeFtc('person/empty_list')
							})
						}
						// изменим стандартную ширину выпадающего списка
						this.$nextTick(() => {
							if (this.$ulBlock)
							{
								let _css = {
									width: this.$ulBlock.parent().css('display') === 'block' ? 'calc(100% - 150px)' : '100%'
								}
								if (!this.$ulBlock.parent().hasClass('multiselect--above'))
									_css['top'] = '55px'
								this.$ulBlock.css(_css)
							}
						})
					}
				}

				//-------------------------------------------------------------
			}

			// обновим подсказки
			this.getTopHint()
		},
		// изменили текущий список (curList) для поля "list"
		'listOptions': function() {
			// частный случай - создание тикета сотрудником
			if (this.$store.state.user_type === 'admin' &&
				this.crud === 'ticket' && this.action === 'create' &&
				this.Field.type === 'list' &&
				this.Field._field_name.indexOf('multi_value') > -1)
			{
				// переделаем список
				if (this.curList && this.curList.length)
				{
					for (let idx = 0; idx < this.curList.length; idx++)
					{
						let _item = this.curList[idx]
						// если есть поля "archive" или "active" - ставим их всегда TRUE
						if ('archive' in _item)
						{
							this.$set(this.curList[idx], 'archive', true)
						}
						if ('active' in _item)
						{
							this.$set(this.curList[idx], 'active', true)
						}
					}
				}
			}

			// частный случай для документов
			if (this.crud === 'document' && (this.Field['_field_name'] === 'payer_id' || this.Field['_field_name'] === 'operation_id'))
			{
				if (this.curList && this.curList.length)
				{
					// просто берем первое значение
					this.listValue = this.curList[0]
					this.fieldCurValue = this.listValue['id']
				}
				else
				{
					// обнуление значения
					this.listValue = null
					this.fieldCurValue = null
					// просим поле с операциями очистится
					if (this.Field['_field_name'] === 'payer_id')
						EventBus.$emit('w5-clear-list-field', 'operation_id')
				}

				this.$emit('input', this.fieldCurValue)
				this.$emit('valueChanged', this.Field)
			}

			// частный случай для документов - по идее это должно быть стандартное поведение для всех списков!
			if (this.crud === 'operation' && this.Field['_field_name'] === 'payer')
			{
				if (this.curList && this.curList.length)
				{
					// если нет значения
					if (this.Field['value'] === null || this.Field['value'] === undefined)
					{
						// обнуление значения
						this.listValue = null
						this.fieldCurValue = null
					}
					else
					{
						// по умолчанию берем первое значение
						this.listValue = this.curList[0]
						this.fieldCurValue = this.listValue['id']

						// ищем установленное значение в списке
						for (let i = 0; i < this.curList.length; i++)
						{
							const item = this.curList[i]
							if (String(this.Field['value']) === String(item.id))
							{
								this.listValue = this.curList[i]
								this.fieldCurValue = item.id
								break
							}
						}
					}
				}
				else
				{
					// обнуление значения
					this.listValue = null
					this.fieldCurValue = null
				}

				this.$emit('input', this.fieldCurValue)
				this.$emit('valueChanged', this.Field)
			}

			// вычисляем направление открытия списка
			this.listOpenDirection()
		},
		// изменили видимость поля
		'Field._visible': function(value, oldValue) {
			if (this.crud === 'vds' && this.action === 'create')
			{
				// при скрытии - выключаем значение
				if (this.Field._field_name === 'backup_auto')
				{
					// показ
					if (value && !oldValue)
					{
						// превоначальное значение
						if ('_initFirstValue' in this.Field)
						{
							this.fieldCurValue = this.Field._initFirstValue
							this.$emit('input', this.fieldCurValue)
						}
						else this.Field._initFirstValue = this.fieldCurValue
					}

					// скрытие
					if (!value && oldValue)
					{
						this.Field._initFirstValue = this.fieldCurValue
						this.fieldCurValue = false
						this.$emit('input', this.fieldCurValue)
					}
				}
			}
		},
		// изменили видимость поля
		'fieldVisible': function() {
			// если это поле меток тикетов
			if (this.Field._field_name === 'set_label')
				this.$nextTick(() => { this.ticketLabelSelected($(this.$el)) })

			// если это поле плательщика в форме оплаты
			if (this.crud === 'operation' &&
				this.Field._field_name === 'payer' && (this.Field.type === 'list' || this.Field.type === 'urlButton') &&
				this.Field._visible)
			{
				// генерация события - показ диалога создания плательщика
				// только если список пуст
				if (!this.Field.list || !this.Field.list.length)
				{
					if (this.$store.state.user_type === 'client')
						EventBus.$emit('w5-show-payer-dialog')
				}
			}
		}
	},
	//=========================================================================
	// компоненты
	//=========================================================================
	components: {
		numberInput,
		domainInput,
		Multiselect,
		fileComponent,
		directFileComponent,
		planComponent,
		groupPlanComponent,
		planSslComponent,
		planDomainComponent,
		templateComponent,
		templateImageComponent,
		paymentComponent,
		urlButtonComponent,
		countryComponent,
		radioListComponent,
		manualDateComponent,
		phoneComponent,
		passportComponent,
		addressComponent,
		Datepicker,
		userRole,
		DateTime,
		savedPaymentsComponent,
		VueSlider,
		OuterDiskType,
		backupComponent
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.removeRightPadding {
	padding-right: 0 !important;
}

.removeAllPadding {
	padding: 0 !important;
}

.with-awesome-button {
	margin-right: 60px !important
}

.with-awesome-button .fontawesome-btn {
	position: absolute;
	top: 22px;
	right: -30px;
	font-size: 20px;
	color: #999;
	transition: all 0.2s;
	cursor: pointer
}
.with-awesome-button .fontawesome-btn:hover {
	color: #333;
}
.with-awesome-button .fontawesome-btn.trash-alt:hover {
	color: red;
}

.w5-field.w5-autoprolong-field {
	border: 1px solid #eee;
	border-radius: 4px;
	padding: 15px;
	margin: 10px 10px 10px 0;
}

.paddingWithButton {
	padding-right: 44px !important;
}
.paddingWithButton.eye {
	padding-right: 68px !important;
}

.padding-for-submit-button {
	padding-right: 60px !important;	
}
.with-submit-button {
	padding: 6px 30px 0 10px !important;
}
.btn-in-field {
	position: absolute;
	right: 0;
	top: 10px;
	height: 41px;
	line-height: 45px;
	padding: 0 18px;
}

.w5-filed-with-top-hint {
	margin-top: 6px;
}

.w5-field-top-hint {
	position: relative;
    top: -6px;
    padding: 10px;    
	border-radius: 4px;
	font-size: 90%;
	font-weight: 300;
	background: #fff5ee;
	border: 1px solid #f9caa7;
}
.w5-field-top-hint::before, .w5-field-top-hint::after {
	content: '';
	position: absolute;
	left: 20px; bottom: -10px;
	border: 5px solid transparent;
	border-top: 5px solid #f9caa7;
}
.w5-field-top-hint::after {
	border-top: 5px solid #fff5ee;
	bottom: -8px; 
}

.w5-filed-with-bottom-hint {
	margin-bottom: 6px;
}

.w5-field-bottom-hint {
	position: relative;
    top: 6px;
    padding: 10px;    
	border-radius: 4px;
	font-size: 90%;
	font-weight: 300;
	background: #fff5ee;
	border: 1px solid #f9caa7;
}
.w5-field-bottom-hint::before, .w5-field-bottom-hint::after {
	content: '';
	position: absolute;
	left: 20px; top: -10px;
	border: 5px solid transparent;
	border-bottom: 5px solid #f9caa7;
}
.w5-field-bottom-hint::after {
	border-bottom: 5px solid #fff5ee;
	top: -8px; 
}

.w5-field-right-hint {
	position: absolute;
    top: 10px;
    left: calc(100% - 2px);
    padding: 10px;    
	border-radius: 4px;
	font-size: 90%;
	font-weight: 300;
	background: #fff5ee;
	border: 1px solid #f9caa7;
	z-index: 10;
	width: calc(100% - 10px);
	min-height: 45px;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	align-items: center;
	-webkit-align-items: center;
}
.w5-field-right-hint.count-1 {
	display: none;
}
.w5-field-right-hint.count-2 {
	width: calc(100% - 10px);
}
.w5-field-right-hint.count-3 {
	width: calc(200% - 10px);
}
.w5-field-right-hint.count-4 {
	width: calc(300% - 10px);
}
.w5-field-right-hint::before, .w5-field-right-hint::after {
	content: '';
	position: absolute;
	left: -10px; top: 15px;
	border: 5px solid transparent;
	border-right: 5px solid #f9caa7;
}
.w5-field-right-hint::after {
	border-right: 5px solid #fff5ee;
	top: 15px; left: -8px;
}

.w5-field-instead-hint {
    padding: 10px;    
	border-radius: 4px;
	font-size: 90%;
	font-weight: 300;
	background: #fff5ee;
	border: 1px solid #f9caa7;
	z-index: 100;
	width: calc(100% - 2px);
	min-height: 45px;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	align-items: center;
	-webkit-align-items: center;
}

.w5-field-instead-hint.error {
	color: red;
	background-color: #fec8c1;
	border: 1px solid #fe9c8f;
}

@media (max-width: 767px) {
	.w5-field-right-hint {
		position: relative;
	    top: 6px; left: auto;
	    padding: 10px;    
		border-radius: 4px;
		font-size: 90%;
		font-weight: 300;
		background: #fff5ee;
		border: 1px solid #f9caa7;
	}
	.w5-field-right-hint::before, .w5-field-right-hint::after {
		content: '';
		position: absolute;
		left: 20px; top: -10px;
		border: 5px solid transparent;
		border-bottom: 5px solid #f9caa7;
	}
	.w5-field-right-hint::after {
		border-bottom: 5px solid #fff5ee;
		top: -8px; 
	}
	.w5-field-right-hint.count-1 {
		width: 100%
	}
	.w5-field-right-hint.count-2 {
		width: 100%
	}
	.w5-field-right-hint.count-3 {
		width: 100%
	}
	.w5-field-right-hint.count-4 {
		width: 100%
	}
}

span.bordered {
	background-color: #ccc;
}

.w5-field-placeholder {
	position: absolute;
	left: 20px;
	height: 45px;
	width: calc(100% - 60px);
	padding: 3px 0;
	line-height: 39px;
	font-weight: 400;
	color: #ccc;
	user-select: none;
	pointer-events: none;
	z-index: 0;

	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;

	/* убрали анимацию вообще
	transition: all 0.05s;*/
}

.w5-field-placeholder.search-in-modal {
	line-height: 36px;
}

.w5-field-placeholder.field-in-modal {
	line-height: 36px;	
}

.w5-field-placeholder .required-field {
	color: #ccc;
}

.w5-field-placeholder.active {
	font-size: 75%;
	line-height: 1;
	color: #9f9f9f;
}

.w5-field-placeholder.active .required-field {
	color: red;
}

.w5-field-placeholder.with-top-hint {
	left: 30px;
}

.w5-field-placeholder.short {
	left: 12px;
}

.w5-field-placeholder.readonly {
	z-index: 1;
}

.w5-field-placeholder.active.textarea {
	z-index: 1;
	background-color: white;
	height: 16px;
	width: calc(100% - 50px);	
	top: 11px;
}

input.bitbtn-in-field {
	width: calc(100% - 130px) !important;
	margin-right: 10px;
}

div.field-button-wrapper.bitbtn-in-field {
	right: 145px;
}

div.field-button-wrapper.search-in-modal {
	top:  17px;
}

.btn.btn-submit.bitbtn-in-field {
	position: relative;
	top: -4px;
	height: 45px;
	line-height: 45px;
}

.btn.btn-submit.bitbtn-in-field.not-text {
	top: 0;
	width: 100%;
}

.btn.btn-submit.bitbtn-in-field.green {
	background: #2cc88a;
	border-color: #2cc88a;
}
.btn.btn-submit.bitbtn-in-field.green:hover {
	background: #2cd88a;
	border-color: #2cd88a;
}

.w5-field.with-big-button {
	display: flex;
}

.w5-field-qa-result {
	width: 100%;
	font-size: 90%;
	color: #555;
	background-color: #f9f9f9;
    margin-top: 2px;
    border-radius: 4px;
    padding: 5px;
}
.w5-field-qa-result ul {
	margin-bottom: 0;
}

.domains-person-with-button {
	float: left;
	width: calc(100% - 140px);
}

.domains-person-create-button {
	font-size: 12px;
	font-weight: 400;
	float: right;
}

.domains-person-error-message {
	display: inline-block;
	left: 0;
    top: 56px;
}

.w5-boolean-label {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	align-items: center;
	-webkit-align-items: center;

	height: 3em;
}
.w5-boolean-hint {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;

	height: 3em;
	color: #999;
	margin-left: 20px;
	font-size: 85%;
}

.w5-boolean-field-wrapper {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	align-items: center;
	-webkit-align-items: center;
}

.w5-boolean-field-wrapper > .link-by-boolean {
	margin-left: 10px;
}

@media (max-width: 767px) {
	input.bitbtn-in-field {
		width: 100% !important;
		margin-right: 0;
		margin-bottom: 10px;
	}

	span.btn.btn-submit.bitbtn-in-field {
		width: 100%;
	}

	div.field-button-wrapper.bitbtn-in-field {
		right: 14px;
	}

	.w5-boolean-label {
		flex-direction: column;
		justify-content: center;
		-webkit-justify-content: center;
		align-items: start;
		-webkit-align-items: start;
		height: auto;
		min-height: 3em;
	}

	.w5-boolean-hint {
		margin: 0;
		font-size: 11px;
		height: 2em;
	}

	.w5-combo-list {
		display: flex;
		display: -webkit-box;
		display: -webkit-flex;
		flex-direction: column;
	}

	.domains-person-with-button {
		width: 100%;
	}
}

div.backup-dialog-service-option {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	align-items: center;
	-webkit-align-items: center;
}
div.backup-dialog-service-option > img {
	width: 32px;
	height: 32px;
	margin-right: 5px;
}
div.backup-dialog-service-option span.flag-icon {
	margin-right: 5px;
}
div.backup-dialog-service-option > div.plan {
	font-size: 12px;
	font-weight: 500;
	color: #333;
}
div.backup-dialog-service-option > div.plan .plan-info {
	font-size: 9px;
	font-weight: 300;
	color: #666;
}
div.backup-dialog-service-option > div.plan .not {
	color: #999;
}

@media (min-width: 1921px) {
	span.btn.btn-submit.bitbtn-in-field {
		font-size: 14px;
	}	
}

.backup-item-cost { font-weight: 700; font-size: 20px; margin: -2px 5px 0 5px; }

.w5-field.header > div.header {
	margin-bottom: -5px;
	height: 30px;
	font-size: 18px;
	font-weight: 500;
	line-height: 30px;
}

.w5-field.header > div.header > span.step {
	display: inline-block;
	margin-right: 6px;
	width: 30px;
	height: 30px;
    border: 1px solid #2c8ad8;
    border-radius: 50%;
    background-color: #2c8ad8;
    color: #fff;
    line-height: 29px;
    text-align: center;
}
.w5-application.mc .w5-field.header > div.header > span.step {
    border: 1px solid #01196f;
    background-color: #01196f;
}

@media (max-width: 590px) {
	.w5-field.header > div.header {
		font-size: 13px;
	}

	.w5-field.header > div.header > span.step {
		font-size: 18px
	}
}

.w5-field.clear-text {
	flex: 1 1 auto;

	-webkit-flex: 1;
	-webkit-flex-grow: 1;
	-webkit-flex-shrink: 1;
	-webkit-flex-basis: auto;
}

.w5-field.clear-text > .shown-text {
	display: block;
	height: 3em;
	width: 70px;
	font-weight: 500;
	line-height: 3em;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.w5-field.clear-text > .shown-text > .lamp {
	float: left;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	background-color: #ccc;
	margin-top: 14px;
	margin-right: 7px;
	transition: all 0.2s;
}
.w5-field.clear-text > .shown-text > .lamp.active {
	background-color: #33cc66
}

.w5-field-progress {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;

	position: absolute;
	height: 43px;
	top: 11px;
	right: 13px;
	text-align: center;
	z-index: 100;
	background-color: white;

}
.w5-field-progress .indicator {
	padding-left: 10px;
	font-size: 11px;
	width: 34px;
}
.w5-field-progress .button {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: center;
	-webkit-align-items: center;

	margin-left: 20px;

	width: 34px;
	height: 34px;
	transition: all 0.2s;
	color: #999;
	cursor: pointer;
}
.w5-field-progress .button:hover {
	color: red;
}

.w5-field > .graph-slider-wrapper {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: space-between;
	-webkit-justify-content: space-between;
	align-items: center;
	width: 100%;
}

.w5-field > .graph-slider-wrapper.update {
	margin-bottom: 32px;
}

.w5-field > .graph-slider-wrapper > .graph-slider {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	flex-direction: column;
	justify-content: center;
	-webkit-justify-content: center;
	align-items: center;
	width: calc(100% - 240px)
}
.w5-field > .graph-slider-wrapper > .graph-slider > .title {
	width: 100%;
	line-height: 1;
}
.w5-field > .graph-slider-wrapper > .graph-slider > .slider {
	width: 100%;
	padding: 0 24px 0 4px;
	margin-bottom: 12px;
}
.w5-field > .graph-slider-wrapper > .graph-slider > .alert {
	display: inline-block;
	padding: 6px;
	margin: 10px 0;
	align-self: start;
}

.w5-field > .graph-slider-wrapper > .input-text-slider {
	position: relative;
	width: 200px;
}

@media (max-width: 620px) {
	.w5-field > .graph-slider-wrapper > .graph-slider {
		width: calc(100% - 160px)
	}
	.w5-field > .graph-slider-wrapper > .input-text-slider {
		width: 150px;
	}
}

@media (max-width: 420px) {
	.w5-field > .graph-slider-wrapper {
		flex-direction: column;
	}
	.w5-field > .graph-slider-wrapper > .graph-slider {
		width: 100%
	}
	.w5-field > .graph-slider-wrapper > .input-text-slider {
		width: 100%;
		margin-bottom: 20px;
	}
	.w5-field > .graph-slider-wrapper > .graph-slider > .title {
		font-size: 11px;
	}
}

.w5-field > .graph-slider-wrapper > .input-text-slider .input-slider-field-placeholder {
	position: absolute;
	font-size: 75%;
	left: 20px;
	user-select: none;
	pointer-events: none;
	z-index: 0;
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	color: #9f9f9f;
	padding: 3px 0 0;
	line-height: 1;
}

.w5-field > .graph-slider-wrapper > .input-text-slider input.input-slider-field {
	position: relative;
	padding-right: 44px;
}

.w5-field > .graph-slider-wrapper > .input-text-slider .input-slider-field-postfix {
	position: absolute;
	top: 14px;
	right: 16px;
	height: 1em;
	font-size: 100%;
	font-weight: 300;
	color: #ccc;
	pointer-events: none;
}

.w5-field > .graph-slider-wrapper > .input-text-slider > .input-slider-field-error {
	display: block;
	position: absolute;
	border-radius: 4px;
	color: red;
	background-color: #fec8c1;
	border: 1px solid #fe9c8f;
	font-size: 90%;
	font-weight: 300;
	padding: 4px 10px;
	margin-top: 6px;
	margin-bottom: 0;
	z-index: 13;
}
.w5-field > .graph-slider-wrapper > .input-text-slider > .input-slider-field-error::before,
.w5-field > .graph-slider-wrapper > .input-text-slider > .input-slider-field-error::after {
	content: '';
	position: absolute;
	left: 20px;
	top: -9px;
	border: 4px solid transparent;    
	border-bottom: 4px solid #fe9c8f;
}
.w5-field > .graph-slider-wrapper > .input-text-slider > .input-slider-field-error::after {
	top:  -7px;
	border-bottom: 4px solid #fec8c1;
}

.w5-field > .outer-disks-update {
	flex-direction: column;
	align-items: flex-start;
}

.w5-field > .outer-disks-update > .outer-disks-hint {
	font-weight: normal;
	color: #666;
	padding: 0;
}
</style>

<style>
.w5-field > .graph-slider-wrapper > .graph-slider > .slider .vue-slider-process {
    background-color: #2c8ad8
}
.w5-application.mc .w5-field > .graph-slider-wrapper > .graph-slider > .slider .vue-slider-process {
    background-color: #01196f
}
</style>



// WEBPACK FOOTER //
// formfield.vue?178682cc